const viVN = {
  common: {
    setbtn: "Đã cài đặt",
    link: "Liên kết bạn bè",
    more: "Thêm thông tin",
    website: "Trang chính thức",
    global: "Toàn cầu",
    goods: "Hàng hóa",
    service: "Dịch vụ",
    mallExchange1: "Nhà cung cấp trực tiếp",
    mallExchange2: "Nền tảng thương mại chuỗi",
  },
  commonTime: {
    minute1: "1 phút",
    minute5: "5 phút",
    minute15: "15 phút",
    minute30: "30 phút",
    hour1: "1 giờ",
    hour2: "2 giờ",
    hour4: "4 giờ",
    day1: "1 ngày",
    week1: "1 tuần",
    month1: "1 tháng",
  },
  tipsVal: {
    copyerror: "Sao chép thất bại!",
    copySucess: "Sao chép thành công!",
    noDataTips: "Chưa có dữ liệu~",
    noBankCardTips: "Chưa thêm thông tin thẻ ngân hàng~",
    inputPlaceholder: "Vui lòng nhập nội dung",
    inputPlaceholder1: "Vui lòng nhập",
    networkType: "Loại mạng",
    phone: "Điện thoại",
    logoutTips: "Thao tác này sẽ đăng xuất, bạn có muốn tiếp tục?",
    setChoiceAddress: "Cài đặt địa chỉ rút tiền",
    userAuthenticate: "Chưa xác thực danh tính",
  },
  depositRisk: {
    addressUpdating:
      "Tạm thời không thể lấy địa chỉ nạp tiền. Vui lòng làm mới và thử lại sau.",
    detail: "Chi tiết nạp tiền",
    CREDITED: "Đã ghi có",
    FROZEN: "Đã đóng băng",
    CHECKING: "Đang kiểm tra",
    REVIEW_PENDING: "Chờ xét duyệt",
    CONFIRMING: "Đang xác nhận",
    PROCESSING: "Đang xử lý",
    REJECTED: "Đã từ chối",
    credited: "Tiền đã được cộng vào số dư khả dụng.",
    frozen:
      "Địa chỉ nguồn liên quan đến nguồn tiền rủi ro cao. Khoản nạp chưa được ghi có và đang chờ xét duyệt thủ công.",
    pending: "Khoản nạp đang được xử lý. Vui lòng tải lại sau.",
    asset: "Xem số dư tài sản",
    security: "Kiểm tra bảo mật",
    PASSED: "Đã thông qua",
    MANUAL_APPROVED: "Đã duyệt thủ công",
    UNDER_REVIEW: "Đang xét duyệt thủ công",
    TIMEOUT_RELEASED: "Đã ghi có theo quy tắc hết thời gian kiểm tra",
    LEGACY: "Khoản nạp cũ; không có hồ sơ kiểm tra",
    PENDING: "Đang chờ",
    CHECK_FAILED: "Kiểm tra lỗi; chờ xét duyệt",
    created: "Thời gian gửi",
    creditedAt: "Thời gian ghi có",
    freezeTime: "Thời gian đóng băng",
    hash: "Mã giao dịch",
    from: "Địa chỉ nguồn",
    to: "Địa chỉ nạp",
    network: "Mạng",
    confirmations: "Xác nhận khối",
    refresh: "Tải lại",
    unavailable: "Không thể tải chi tiết. Vui lòng thử lại.",
    contact: "Cần hỗ trợ, vui lòng liên hệ",
    notice:
      "Địa chỉ nguồn được kiểm tra sau khi xác nhận trên chuỗi. Khoản nạp rủi ro cao và mọi khoản nạp vào địa chỉ nhận đã bị đánh dấu ô nhiễm đều cần được xét duyệt thủ công từng khoản trước khi ghi có.",
    transactionInfo: "Thông tin giao dịch",
    coin: "Loại tiền",
    amount: "Số tiền nạp",
    fundsFrozen: "Tiền đã bị đóng băng",
    highRiskSource: "Liên quan đến địa chỉ rủi ro cao",
    HIGH_RISK: "Rủi ro cao",
    UNKNOWN: "Chưa có hồ sơ kiểm tra",
  },
  verifyUser: {
    title: "Xác thực danh tính",
    country: "Nơi cư trú",
    name: "Tên",
    familyName: "Họ",
    idcardNo: "Số giấy tờ tùy thân",
    upload: "Tải lên",
    reminder: "Lưu ý",
    reminderValue:
      "· Đảm bảo họ tên và số giấy tờ của bạn hiển thị rõ ràng trên ảnh",
    tips: {
      type: "Định dạng JPEG hoặc PNG, ",
      size: "Không quá 2MB",
      idcardImg: "Vui lòng tải lên ảnh giấy tờ tùy thân",
      idcardFrontImgurl:
        "Tải lên ảnh mặt trước giấy tờ tùy thân ở định dạng PNG hoặc JPEG",
      idcardBackImgurl:
        "Tải lên ảnh mặt sau giấy tờ tùy thân ở định dạng PNG hoặc JPEG",
    },
  },
  vip: {
    register: "Người dùng đã đăng ký",
    member: "Thành viên",
    copartner: "Đối tác",
    diamond: "Đối tác kim cương",
  },
  news: {
    title: "Tin tức, sự kiện và thông báo",
    titleInfo:
      "Tập trung vào chiều sâu và xu hướng tiên phong của ngành, phân tích sâu về xu thế và cơ hội",
    tabVal1: "Thông báo hệ thống",
    tabVal2: "Thông báo nền tảng",
    tabVal3: "Tin tức sự kiện",
    tabVal4: "Báo cáo nghiên cứu",
    moreTips: "Thêm thông báo",
    noDataTips: "Chưa có nội dung~",
  },
  buy_box: {
    buy: "Mua vào",
    buy_price: "Giá mua",
    sell: "Bán ra",
    sell_price: "Giá bán",
    use: "Khả dụng",
    amount: "Số lượng",
    money: "Số tiền",
    loading: "Đăng nhập",
    add_success: "Đặt lệnh thành công",
    trans_confirm: "Xác nhận giao dịch",
    buy_confirm: "Xác nhận mua",
    sell_confirm: "Xác nhận bán",
    trans_amount: "Giá trị giao dịch",
    trans_password_placeholder: "Vui lòng nhập mật khẩu giao dịch",
    confirm: "Xác nhận",
    cancel: "Hủy",
    verification: "Xác minh",
    withdraw: "Rút tiền",
    chain_withdraw: "Rút tiền on-chain",
    input_error: "Số tiền hoặc số lượng phải lớn hơn 0",
  },
  nav: {
    home: "Trang chủ",
    mall: "Cửa hàng",
    ctc: "Thị trường thứ cấp",
    otc: "Giao dịch tiền pháp định",
    faq: "Câu hỏi thường gặp",
    partner: "Chương trình thành viên",
    financial: "Tài chính RWA",
    burst: "Phần thưởng nổ khối",
    apply: "Đăng ký niêm yết",
    download: "Tải APP",
    order: "Đơn hàng",
    assets: "Tài sản",
    login: "Đăng nhập/Đăng ký",
    mine: "Của tôi",
    ann_more: "Xem thêm>>",
    ann_drop: {
      system: "Thông báo hệ thống",
      ann: "Thông báo nền tảng",
      news: "Tin tức ngành",
      login: "Đăng nhập để xem",
    },
    user_drop: {
      partner_register: "Người dùng đã đăng ký",
      partner_member: "Thành viên",
      partner_partner: "Đối tác",
      partner_diamond: "Đối tác kim cương",
      center: "Trung tâm cá nhân",
      address: "Quản lý địa chỉ rút tiền",
      order: "Quản lý đơn hàng",
      receipt: "Cài đặt thanh toán",
      api: "Quản lý API",
      out: "Đăng xuất",
    },
  },
  mall: {
    title: "Cửa hàng",
    status1: "Đang diễn ra",
    status2: "Chưa bắt đầu",
    status3: "Kết thúc đăng ký mua",
    status4: "Đăng ký N/A",
    assetType: "Loại tài sản",
    assetTime: "Thời gian phát hành",
    assetPrice: "Giá phát hành",
    issuanceTotal: "Tổng lượng phát hành",
    outstandingUnits: "Tổng lượng lưu hành",
    delivery: "Khu vực giao hàng",
    payPrice: "Mua tối thiểu",
    typeGoods: "Hàng hóa",
    typeService: "Dịch vụ",
    mallUrl: "Nền tảng thương mại chuỗi",
    showDetail: "Nhấn để xem",
    subscription_price: "Giá đăng ký mua",
    share_quantity: "Số lượng mỗi phần",
    total_supply: "Tổng số phần phát hành",
    total_value: "Tổng giá trị phát hành",
    shares_unit: "phần",
    issue_unit: "phần",
    pieces_per_share: "cái/phần",
    pre_sale: "Mua trước",
    open_sale: "Mua mở",
    view_details: "Xem chi tiết",
    starts: "Bắt đầu",
    ends: "Kết thúc",
    detail: {
      title: "Chi tiết hàng hóa",
      type: "BNB Smart Chain",
      typeInfo: "Phát hành bởi MEIMEI INTERNATIONAL HOLDINGS LIMITED",
      btn1: "Vào thị trường thứ cấp",
      btn2: "Nền tảng thương mại chuỗi",
      tab1: "Chi tiết",
      tab2: "Tài liệu",

      goodsType: "Loại sản phẩm",
      mallExchange: "Đổi",
      debutStartTime: "Bắt đầu phát hành lần đầu",
      debutEndTime: "Kết thúc phát hành lần đầu",
      goodsName: "Tên niêm yết",
      symbol: "Ký hiệu",
      network: "Mạng",
      protocol: "Giao thức",
      contract: "Địa chỉ hợp đồng",
      issuer: "Bên phát hành",
      publishAmount: "Tổng lượng phát hành",
      tradeAmount: "Tổng lượng giao dịch",
      decimal: "Độ chính xác",
      totalValue: "Tổng giá trị phát hành",
      firstValue: "Phát hành đợt đầu",
      minBuyAmount: "Lượng mua tối thiểu",
      maxBuyAmount: "Lượng mua tối đa",
      showWhitePage: "Xem sách trắng",

      chainInfo: "Thông tin on-chain",
      view: "Xem",
      hide: "Ẩn",

      noData: "Chưa có sản phẩm cửa hàng~",

      coinInfo1: "Liên minh 100 doanh nghiệp niêm yết hàng đầu Hồng Kông TNHH",
      coinInfo2: "RWA Group Limited",
      coinInfo3: "Meimei International Holdings Limited",
    },
  },
  mallDetail: {
    title: "Chi tiết token",
    issue_price: "Giá phát hành",
    issue_amount: "Số lượng phát hành",
    min_buy_shares: "Số phần mua tối thiểu",
    max_buy_shares: "Số phần mua tối đa",
    subscription_period: "Kỳ đăng ký mua",
    distribution_start: "Bắt đầu phân phối",
    distribution_end: "Kết thúc phân phối",
    start_trading: "Bắt đầu giao dịch",
    purchase_info: "Thông tin đăng ký mua",
    max_subscription: "Có thể mua tối đa",
    purchase_price: "Giá đăng ký mua",
    subscribed: "Đã đăng ký mua",
    share: "phần",
    whitelist_info: "Thông tin whitelist",
    whitelist_status: "Trạng thái whitelist",
    whitelist_max: "Mua tối đa của whitelist",
    remaining_buy: "Còn có thể mua",
    enabled: "Đã bật",
    disabled: "Chưa bật",
    chain_info: "Thông tin on-chain",
    network: "Mạng",
    blockchain: "Blockchain",
    protocol: "Giao thức",
    contract_address: "Địa chỉ hợp đồng",
    whitepaper: "Sách trắng",
    explorer: "Trình duyệt",
    view_whitepaper: "Xem sách trắng",
    copy: "Sao chép",
    copy_success: "Sao chép thành công",
    copy_fail: "Sao chép thất bại",
    faq: "Câu hỏi thường gặp",
    buy_now: "Mua ngay",
    ended: "Đã kết thúc",
    waiting: "Đang chờ",
    will_open: "Sắp bắt đầu",
    please_login: "Vui lòng đăng nhập",
    non_whitelist: "Không có trong whitelist",
    exceed_max_buy_shares: "Vượt quá số phần mua tối đa",
    started: "Đã bắt đầu",
    day: "ngày",
    hour: "giờ",
    minute: "phút",
    second: "giây",
    sold_progress: "Tiến độ bán",
    sold: "Đã bán",
    remaining: "Còn lại",
  },
  question: {
    title: "Câu hỏi thường gặp",
    info1: "RWA.LTD cung cấp cho người dùng một nền tảng như thế nào?",
    infoText1: "RWA.LTD cung cấp cho người dùng một nền tảng như thế nào?",
    info2: "Yêu cầu và hạn chế khi đăng ký người dùng nền tảng",
    infoText2: "Yêu cầu và hạn chế khi đăng ký người dùng nền tảng",
    info3: "Yêu cầu và hạn chế khi đăng ký người dùng nền tảng",
    infoText3:
      'Nền tảng này triển khai chương trình thưởng giới thiệu cho những người dùng đã hoàn tất xác thực KYC. Nếu người được mời đăng ký tài khoản trên nền tảng thông qua liên kết mời hoặc mã mời và hoàn tất xác thực KYC, người gửi lời mời trong tương lai có thể nhận được hoàn phí giao dịch mua của người được mời (tỷ lệ cấp một 15%, cấp hai 5%). Sau khi xác thực KYC được duyệt, bạn có thể lấy mã mời tại "Trung tâm cá nhân - Quản lý tài khoản - Xem lời mời của tôi", người dùng mới cũng có thể nhấn vào liên kết mời để liên kết quan hệ mời với bạn. Nền tảng này bảo lưu quyền thay đổi nội dung hoạt động nêu trên hoặc hủy bỏ hoạt động nêu trên bất cứ lúc nào, những "cập nhật" hoặc "hủy bỏ" như vậy có thể không được phản ánh kịp thời tại đây.',
    info4: "Vì sao không thể đăng ký hoặc đăng nhập thành công?",
    infoText4: "Vì sao không thể đăng ký hoặc đăng nhập thành công?",
    info5: 'Làm thế nào để mua token khởi nguồn của nền tảng RWA Coin ("RWA")?',
    infoText5:
      'Làm thế nào để mua token khởi nguồn của nền tảng RWA Coin ("RWA")?',
  },
  home: {
    header: {
      title1: "Nền tảng thương mại chuỗi ra mắt hoành tráng",
      title2:
        "Sự kết hợp sáng tạo giữa cơ chế token và kinh tế hàng hóa, mang đến cho bạn trải nghiệm hoàn toàn mới",
      title: "Sàn giao dịch WTZ",
      con: "Chương trình đối tác triệu phú",
      rules: "Xem chi tiết sự kiện>>",
      member_num: "Số lượng thành viên",
      register_num: "Người dùng đã đăng ký",
      register_btn: "Nhấn để đăng ký",
    },
    table: {
      header: {
        userCollect: "Tự chọn",
        search: "Tìm kiếm loại tiền giao dịch",
      },
      row: {
        rwatype: "Token RWA",
        type: "Cặp giao dịch",
        price: "Giá tham chiếu thứ cấp",
        high: "Giá cao nhất 24H",
        low: "Giá thấp nhất 24H",
        rang: "Biên độ tăng giảm 24H",
        volume: "Khối lượng giao dịch 24H",
        amount: "Giá trị giao dịch 24H",
        operation: "Thao tác",
        buy: "Mua vào",
        sell: "Bán ra",
      },
      more: "Xem thêm",
    },
    introduction: {
      h1: "Sàn giao dịch WTZ, sàn giao dịch theo mô hình thành viên lớn nhất thế giới",
      h3: "Cung cấp cho người dùng toàn cầu dịch vụ giao dịch tài sản kỹ thuật số và quản lý tài sản an toàn, đáng tin cậy, chia sẻ lợi ích nền tảng với thành viên toàn cầu",
      part1: {
        title: "Mô hình thành viên độc quyền",
        con: "Áp dụng cách thức cùng xây dựng cộng đồng và chia sẻ lợi ích cho thành viên, tạo nên sàn giao dịch theo mô hình thành viên lớn nhất thế giới",
      },
      part2: {
        title: "Hệ thống ổn định và đáng tin cậy",
        con: "Kiến trúc hệ thống đa tầng đa cụm, công nghệ engine khớp lệnh hiệu suất cao, mã hóa dữ liệu người dùng cấp ngân hàng, xác thực danh tính động,... đảm bảo an toàn giao dịch",
      },
      part3: {
        title: "Đảm bảo an toàn tài sản",
        con: "Các công nghệ tiên tiến như đa chữ ký, chữ ký ngoại tuyến, kết hợp ví lạnh và ví nóng,... cung cấp cho khách hàng dịch vụ giao dịch tài sản kỹ thuật số an toàn, đáng tin cậy",
      },
      title: {
        merchant1: "Người bán",
        merchant2: "Người mua",
        text1: "Cải cách sáng tạo kinh tế hàng hóa",
        text2:
          "RWA.LTD thông qua sự kết hợp sáng tạo giữa cơ chế token và thị trường hàng hóa, cung cấp cho người mua và người bán kênh giao dịch cũng như mô hình giao dịch trong kỷ nguyên WEB3.",
        text3: "Giải pháp token thương hiệu phi tài chính tùy chỉnh",
        text4:
          "Vì sao các thương hiệu lại đến? Dòng tiền doanh thu trả trước + Vận hành nhẹ có thể dự đoán + Cộng đồng lưu lượng người hâm mộ thương hiệu được quản lý hiệu quả",
        text5: "Tận hưởng giao dịch token bán lẻ không rào cản",
        text6:
          'Vì sao người tiêu dùng lại đến? Giao dịch on-chain liên tục 24/7 + Lý do rời bỏ thương hiệu bất cứ lúc nào + Giá bán trước hấp dẫn hơn + Hàng "tươi mới" có thể chuyển nhượng bất cứ lúc nào',
        text7: "Viết lại kinh tế hàng hóa thành kinh tế thương mại chuỗi",
        text8:
          "Thông qua việc tuyển chọn tài sản phi tài chính đa dạng nhưng chất lượng cao, thiết kế chân dung người dùng bán lẻ hướng tới tất cả mọi người, cùng sự tích hợp đột phá giữa giao dịch và sưu tầm, RWA.LTD dựa trên nền kinh tế thực, lấy quyền lợi người dùng làm điểm xuất phát hàng đầu, nỗ lực cung cấp cho mọi người một nền tảng giao dịch token đáng tin cậy, có giá trị làm chỗ dựa và thực sự vận dụng lợi ích của công nghệ blockchain.",
        text9: "Tin tức, sự kiện và thông báo",
        text10: "Thêm thông báo",
      },
    },
    download: {
      title: "Mọi lúc mọi nơi, giao dịch dễ dàng hơn",
      con: "Sàn giao dịch WTZ cung cấp cho người dùng terminal giao dịch, hỗ trợ IOS, Android và Web, đồng thời cung cấp dịch vụ API độ trễ mili-giây cho nhà giao dịch chuyên nghiệp, ngôn ngữ bao gồm tiếng Trung, tiếng Anh,... cam kết mang đến cho khách hàng trải nghiệm đầu tư hàng đầu",
      ios: "Tải IOS",
      android: "Tải Android",
    },
    register: {
      title: "Đăng ký tài khoản WTZ, bắt đầu hành trình tiền kỹ thuật số",
      placeholder: "Vui lòng nhập số điện thoại hoặc email",
      btn: "Đăng ký ngay",
    },
    footer: {
      about: "Về chúng tôi",
      legal: "Điều khoản nền tảng",
      terms: "Thỏa thuận người dùng",
      buyProtocol: "Thỏa thuận mua",
      questions: "Câu hỏi thường gặp",
      ecosystem: "Hệ sinh thái",
      rwaApp: "Ứng dụng RWA",
      emailAddress: "Địa chỉ email",
      companyaddress: "Địa chỉ công ty",
      production: "Sản phẩm",
      question: "Phản hồi vấn đề",
      rate: "Biểu phí",
      partner: "Trở thành đối tác",
      apply: "Đăng ký niêm yết",
      api: "Kết nối API",
      app: "Tải APP",
      ann_help: "Trợ giúp thông báo",
      off_ann: "Thông báo chính thức",
      help: "Trung tâm trợ giúp",
      agreements: "Thỏa thuận người dùng",
      privacy: "Chính sách bảo mật",
      contact: "Liên hệ chúng tôi",
      business: "Hợp tác kinh doanh",
      service: "CSKH",
      institutional: "Hợp tác tổ chức",
    },
    v2: {
      hero: {
        tag: "RWA.LTD · Hạ tầng RWA cấp tiêu dùng",
        title1: "Kết nối tài sản thế giới thực",
        title2: "Lưu thông trên chuỗi, tạo dựng giá trị nền tảng",
        title3: "",
        desc: "RWA.LTD đưa hàng hóa, dịch vụ và quyền lợi thương mại của thế giới thực lên chuỗi dưới dạng số hóa minh bạch, thông qua lưu thông trên chuỗi và tất toán thực tế, kết nối hàng hóa, dịch vụ và quyền lợi thương mại thực.",
        btn1: "Khám phá RWA cấp tiêu dùng",
        btn2: "Xem phim",
        tag1: "Sản phẩm và thương hiệu",
        tag2: "Thương mại",
        tag3: "Thực hiện",
      },
      banners: {
        card1:
          "Phiên bản mới của RWA.ltd đã ra mắt, hội viên tận hưởng nhiều quyền lợi độc quyền từ thế giới thực",
        card2:
          "GCT, RWA cà phê thương mại chuỗi đầu tiên trên thế giới, đã có mặt trên rwa.ltd",
        card3:
          "Nâng cấp toàn diện, trang web chính thức mới của RWA.LTD đã ra mắt",
        card4:
          "Chuyên về cửa hàng token blockchain, tận hưởng mua sắm không lo lắng",
        btn: "Nhấn để xem",
      },
      quotes: {
        title1: "Thị trường sôi động",
        title2: "Thị trường thứ cấp",
        desc: "Nắm bắt biến động giá tiền mã hóa mới nhất, tận dụng mọi cơ hội giao dịch. RWA cung cấp tính thanh khoản và độ sâu thị trường hàng đầu ngành.",
        totalAssets: "Tổng tài sản",
        todayPnl: "Lãi/lỗ hôm nay",
        viewManage: "Xem và quản lý tài sản",
        partner: "Chương trình đối tác",
        viewAll: "Xem tất cả",
      },
      news: {
        title1: "Tin tức, sự kiện & ",
        title2: "Thông báo",
        viewAll: "Xem tất cả",
        explore: "Khám phá",
      },
      consumer: {
        eyebrow: "MÔ HÌNH RWA TIÊU DÙNG",
        title1: "Từ hàng hóa thực tế",
        title2: "đến quyền lợi kỹ thuật số có thể quản lý",
        item1: {
          title: "Giá trị thương mại thực",
          desc: "Hàng hóa, dịch vụ, quyền thành viên và lợi ích dựa trên thương mại thực tế.",
        },
        item2: {
          title: "Biểu diễn số hóa",
          desc: "Quyền lợi được biểu diễn dưới dạng số hóa với quy tắc rõ ràng và tài liệu dự án có thể xác minh.",
        },
        item3: {
          title: "Lưu thông & Đổi lại",
          desc: "Mạng lưới lưu thông được kết nối theo chiều hướng quay trở lại hàng hóa và dịch vụ thực tế.",
        },
      },
      solutions: {
        eyebrow: "Giải pháp",
        title1: "Từ ý tưởng",
        title2: "đến phát hành, lưu thông và đổi lại",
        link: "Khám phá vòng đời",
        items: {
          commonExplore: "Khám phá",
          issuance: {
            title: "Thiết kế phát hành & Đổi lại",
            desc: "Quy tắc token, cấu trúc quyền lợi và logic đổi lại",
          },
          materials: {
            title: "Tài liệu dự án cốt lõi",
            desc: "Whitepaper, hướng dẫn dự án và tài liệu cần thiết",
          },
          deployment: {
            title: "Triển khai blockchain",
            desc: "Triển khai an toàn, mở rộng phù hợp với mô hình dự án",
          },
          launch: {
            title: "Ra mắt & Truyền thông thương hiệu",
            desc: "Câu chuyện ra mắt và truyền thông dự án",
          },
          circulation: {
            title: "Lưu thông trên nền tảng",
            desc: "Kết nối giữa nền tảng, người dùng và kênh thương mại",
          },
          redemption: {
            title: "Đổi lại & Thực hiện",
            desc: "Giao hàng thực tế, truy cập dịch vụ và thực hiện lợi ích",
          },
        },
      },
      projects: {
        eyebrow: "CÁC DỰ ÁN HỆ SINH THÁI TIÊU BIỂU",
        title1: "Dự án thực tế. ",
        title2: "Giá trị thương mại thực",
        viewAll: "Xem tất cả",
        end: "KẾT THÚC",
        explore: "Khám phá",
      },
      discuss: {
        title1: "Xây dựng thế hệ tiếp theo của",
        title2: "thương mại kỹ thuật số thực tế",
        button: "Trao đổi về dự án của bạn",
      },
      film: {
        p1: "Phim nền tảng hoạt hình",
        title1: "Nền tảng RWA.LTD",
        title2: "Đẩy giá trị thực lên chuỗi",
        desc: "Xem cách tài sản thế giới thực di chuyển từ xác định và phát hành đến lưu thông và thực hiện.",
        btn: "Xem phim",
      },
      infrastructure: {
        eyebrow: "VỀ RWA.LTD",
        title: "Cơ sở hạ tầng cho tương lai",
        title2: "của thương mại kỹ thuật số thế giới thực",
        desc1:
          "RWA.LTD là một nền tảng RWA tiêu dùng giúp các thương hiệu, chủ dự án và thương nhân phát hành, lưu thông và đổi lại quyền thương mại số được bảo chứng bởi tài sản và dịch vụ thực tế.",
        desc2:
          "Chúng tôi kết nối cấu trúc dự án, triển khai số hóa, truyền thông, lưu thông trên nền tảng và thực hiện trong cùng một vòng đời nhất quán.",
        button: "Khám phá mô hình của chúng tôi",
      },
    },
  },
  trade_ctc: {
    trans_start: "sau đó mở giao dịch",
    header: {
      price: "Giá tham chiếu thứ cấp",
      change: "Biên độ tăng giảm 24 giờ",
      high: "Cao nhất 24 giờ",
      low: "Thấp nhất 24 giờ",
      volume: "Khối lượng giao dịch 24 giờ",
      search: "Tìm kiếm loại tiền",
      self: "Tự chọn",
    },
    buyAndSell: {
      price: "Giá",
      volume: "Số lượng",
      money: "Số tiền",
      limit_delegation: "Lệnh giới hạn",
      current_delegation: "Lệnh hiện tại",
      history_delegation: "Lịch sử lệnh",
    },
    delegationTable: {
      time: "Thời gian đặt lệnh",
      pay_type: "Loại giao dịch",
      buy: "Mua vào",
      sell: "Bán ra",
      amount: "Số lượng đặt lệnh",
      beenDone: "Đã khớp",
      price: "Giá đặt lệnh",
      averagePrice: "Giá khớp trung bình",
      money: "Tổng giá trị khớp",
      status: "Trạng thái",
      trading: "Đang giao dịch",
      un_trade: "Chưa giao dịch",
      canceled: "Đã hủy",
      part_completed: "Hoàn thành một phần",
      canceling: "Đang hủy",
      completed: "Đã hoàn thành",
      operation: "Thao tác",
      cancel: "Hủy lệnh",
      cancel_success: "Hủy thành công",
      deleteRecord: "Xóa",
      delete_success: "Xóa thành công",
    },
    deal: {
      title: "Giao dịch mới nhất",
      amount: "Số lượng",
      price: "Giá",
      time: "Thời gian",
    },
    search: {
      placeholder: "Tìm kiếm loại tiền",
      self: "Tự chọn",
      coin_type: "Loại tiền RWA",
      price: "Giá mới nhất",
      range: "Biên độ tăng giảm",
    },
  },
  login: {
    title1: "Chào mừng đăng nhập",
    title: "Chào mừng đăng nhập WTZ",
    pwd: "Mật khẩu",
    tips: "Bạn chưa là người dùng đã đăng ký?",
    phone_login: "Đăng nhập bằng điện thoại",
    email: "Email",
    newemail: "Địa chỉ email mới",
    newemailcode: "Mã xác minh email mới",
    email_login: "Đăng nhập bằng email",
    input_phone1: "Số điện thoại",
    input_phone: "Số điện thoại (chỉ hỗ trợ khu vực Trung Quốc đại lục)",
    input_email: "Vui lòng nhập email",
    input_email1: "Vui lòng nhập email hợp lệ",
    input_password: "Vui lòng nhập mật khẩu",
    login: "Đăng nhập",
    forget: "Quên mật khẩu?",
    no_account: "Chưa có tài khoản?",
    register_now: "Đăng ký ngay",
    verify: "Xác&nbsp;&nbsp;&nbsp;&nbsp;minh",
    close: "Đóng",
    code_input: "Vui lòng nhập mã xác minh",
    hint_google: "Lần đăng nhập này yêu cầu mã xác minh Google",
    hint_email: "Lần đăng nhập này yêu cầu mã xác minh email",
    hint_default:
      "Để bảo mật tài sản của bạn, đăng nhập cần xác minh hai yếu tố",
  },
  register: {
    title1: "Chào mừng đăng ký",
    title: "Chào mừng đăng ký WTZ",
    phone: "Số điện thoại",
    register_phone: "Đăng ký bằng điện thoại",
    register_email: "Đăng ký bằng email",
    input_phone: "Vui lòng nhập số điện thoại",
    input_email: "Vui lòng nhập email",
    code: "Mã xác minh",
    get_code: "Lấy mã xác minh",
    input_code: "Vui lòng nhập mã xác minh",
    input_mes_code: "Vui lòng nhập mã xác minh SMS",
    input_email_code: "Vui lòng nhập mã xác minh email",
    input_password:
      "Vui lòng đặt mật khẩu đăng nhập, 8~32 ký tự số, chữ cái hoặc ký hiệu",
    confirm_password: "Vui lòng nhập lại mật khẩu",
    invite_code: "Mã mời",
    invite_code_tip: "Vui lòng nhập mã mời",
    register: "Đăng ký",
    agree1: "Tôi đã đọc và đồng ý với thỏa thuận người dùng",
    agree: "Tôi đã đọc và đồng ý",
    policy: "《Thỏa thuận người dùng và Chính sách bảo mật》",
  },
  alert: {
    register_success: "Đăng ký thành công",
  },
  validate: {
    account_require: "Tài khoản không được để trống",
    password_require: "Mật khẩu không được để trống",
    code_require: "Mã xác minh không được để trống",
    mes_code_require: "Mã xác minh SMS không được để trống",
    email_code_require: "Mã xác minh email không được để trống",
    google_code_require: "Mã Google Authenticator không được để trống",
    password_formatter_error: "Định dạng mật khẩu không đúng",
    password_formatter_tip: "Mật khẩu là tổ hợp 8 đến 32 ký tự số và chữ cái",
    password_confirm_again: "Vui lòng nhập lại mật khẩu",
    password_confirm_error: "Mật khẩu nhập hai lần không khớp",
    phone_require: "Vui lòng nhập số điện thoại",
    email_require: "Vui lòng nhập email",
    email_formatter_error: "Định dạng email không đúng",
    country_require: "Vui lòng chọn nơi cư trú",
    name_require: "Họ không được để trống",
    familyName_require: "Tên không được để trống",
    id_require: "Số giấy tờ không được để trống",
    depositBank_require: "Ngân hàng mở tài khoản không được để trống",
    bankNum_require: "Số thẻ ngân hàng không được để trống",
    bankNum_confirm_error: "Số thẻ nhập hai lần không khớp",
    trans_password_require: "Mật khẩu giao dịch không được để trống",
    trans_password_formatter_tip:
      "Mật khẩu giao dịch là 6~32 ký tự số hoặc chữ cái",
    alipay_account_require: "Tài khoản Alipay không được để trống",
    wechat_account_require: "Tài khoản WeChat không được để trống",
    geet_require: "Vui lòng hoàn tất xác minh",
    agree_require: "Vui lòng đọc thỏa thuận người dùng trước",
    address_require: "Địa chỉ không được để trống",
    amount_require: "Số lượng không được để trống",
    amount_min: "Không được nhỏ hơn",
    amount_over_0: "Vui lòng nhập số lớn hơn 0",
    type_number: "Phải là số",
    incomplete_information: "Thông tin chưa đầy đủ",
    coin_type_error: "Loại tiền điền không đúng",
    alias_require: "Bí danh địa chỉ không được để trống",
    invite_code_require: "Mã mời không được để trống",
    description_require: "Ghi chú không được để trống",
    roles_require: "Vui lòng chọn quyền API",
    qr_code_require: "Vui lòng tải lên mã QR",
    upload_error: "Tải ảnh lên thất bại!",
    upload_type: "Ảnh tải lên chỉ có thể ở định dạng JPG, JPEG hoặc PNG!",
    upload_size: "Kích thước ảnh đại diện tải lên không được vượt quá 2MB!",
    upload_compress: "Ảnh khá lớn, đang nén...",
    input_err_tips: "Vui lòng nhập nội dung chính xác~",
  },
  user_center: {
    tip: "Nhắc nhở",
    tip_val2:
      "Dùng cho nạp/rút tiền pháp định tuân thủ, vui lòng đảm bảo dùng tài khoản của chính bạn và thông tin chính xác đáng tin cậy!",
    my_share: "Lời mời của tôi",
    my_invite_code: "Mã mời của tôi",
    securitySettings: "Cài đặt bảo mật",
    login_history: "Lịch sử đăng nhập",
    login_safety_history: "Lịch sử cài đặt bảo mật",
    login_text: "Đăng nhập tài khoản",
    login_out_text: "Đăng xuất tài khoản",
    copy_share_url: "Sao chép liên kết mời",
    share_tips_val:
      "Mỗi ngày lúc 08:00:00 (GMT+0800) sẽ hoàn trả phần thưởng mời của 24 giờ trước, phát trực tiếp vào tài khoản coin-coin, vui lòng chú ý nhận.",
    accountManagement: "Quản lý tài khoản",
    accountSettings: "Cài đặt tài khoản",
    apiManagement: "Quản lý API",
    paySettings: "Cài đặt thanh toán",
    orderManagement: "Quản lý đơn hàng",
    saleOrder: "Đơn hàng phát hành",
    marketOrder: "Đơn hàng thị trường",
    see_user_share: "Xem lời mời của tôi",
    update_user_img: "Đổi ảnh đại diện",
    need_bind: "Cần liên kết đồng thời số điện thoại và email",
    need_bind1: "Cần liên kết đồng thời Google Authenticator và email",
    bind_now: "Liên kết ngay",
    need_tran_password: "Cần đặt mật khẩu giao dịch",
    set_now: "Cài đặt ngay",
    need_auth: "Cần xét duyệt danh tính",
    kyc_phone: "Vui lòng xác thực danh tính trên điện thoại",
    i_know: "Tôi đã hiểu",
    cancel: "Hủy",
    base_info: {
      title: "Thông tin cơ bản",
    },
    account_setting: {
      title: "Cài đặt tài khoản",
      add: "Thêm",
      manage: "Quản lý",
      setting: "Cài đặt",
      address: {
        title: "Quản lý địa chỉ rút tiền",
        tip: "Xác thực địa chỉ, đảm bảo an toàn",
      },
      receipt: {
        title: "Cài đặt thanh toán",
        tip: "Đảm bảo an toàn tài khoản",
      },
      api: {
        title: "Cài đặt API",
        tip: "Tạo khóa API",
      },
    },
    account_safe: {
      title: "Bảo mật tài khoản",
      title_tip: "Giữ lại ít nhất hai phương thức xác minh",
      authenticate: "Xác thực",
      not_authenticate: "Chưa xác thực",
      has_authenticate: "Đã xác thực",
      has_authenticate_lvl: "Đã xác thực nâng cao",
      ing_authenticate: "Đang xét duyệt",
      fail_authenticate: "Xét duyệt thất bại",
      fail_reason: "Lý do thất bại:",
      authenticate_again: ", bạn có muốn xác thực lại không?",
      again: "Xác thực lại",
      close: "Đóng",
      detail: "Chi tiết",
      bind: "Liên kết",
      setting: "Cài đặt",
      has_bind: "Đã liên kết",
      not_bind: "Chưa liên kết",
      open: "Bật",
      not_open: "Chưa bật",
      has_open: "Đã bật",
      change: "Đổi",
      modify: "Sửa",
      get_back: "Khôi phục",
      identity: {
        title: "Xác thực danh tính",
        tipsVal: "Xác minh danh tính, vì quyền lợi của bạn",
      },
      login_password: {
        title: "Mật khẩu đăng nhập",
        tip: "Đảm bảo an toàn tài khoản",
      },
      trade_password: {
        btn: "Cài đặt",
        title: "Mật khẩu giao dịch",
        tip: "Đảm bảo an toàn tài khoản",
      },
      phone: {
        title: "Liên kết điện thoại",
        tipsVal:
          "Dùng để nhận SMS xác minh khi rút tiền, đổi mật khẩu, cài đặt bảo mật",
      },
      email: {
        title: "Cài đặt email",
        tipsVal: "Dùng khi đăng nhập, rút tiền, cài đặt bảo mật",
      },
      google: {
        title: "Google Authenticator",
        bind: "Liên kết Google",
        title1: "Mã Google Authenticator",
        tipsVal:
          "Dùng để xác minh an toàn khi rút tiền, khôi phục mật khẩu, sửa cài đặt bảo mật, quản lý API",
        tipsVal2: "Vui lòng liên kết Google Authenticator trước",
      },
      authenticate_trade: {
        title: "Xác minh giao dịch",
        tip: "Đảm bảo an toàn tài khoản",
      },
      alert: {
        con: "Sau khi tắt xác minh an toàn, không thể rút tiền và giao dịch OTC trong 24 giờ",
        close_phone_title: "Xác nhận tắt xác minh điện thoại?",
        close_email_title: "Xác nhận tắt xác minh email?",
        close_google_title: "Xác nhận tắt Google Authenticator?",
        cancel: "Hủy",
        confirm: "Xác&nbsp;&nbsp;&nbsp;&nbsp;nhận",
      },
    },
    table: {
      login_recently: {
        type: "Loại",
        title: "Đăng nhập gần đây",
        time: "Thời gian",
        ways: "Phương thức đăng nhập",
        status: "Trạng thái",
        status1: "Hiện trạng",
        address: "Nơi đăng nhập",
        address1: "Địa chỉ đăng nhập",
        success: "Đăng nhập thành công",
        error: "Thất bại",
        success1: "Thành công",
        fail: "Đăng nhập thất bại",
        unknown: "Không rõ",
      },
      setting_history: {
        title: "Lịch sử cài đặt bảo mật",
        time: "Thời gian",
        safe_setting: "Cài đặt bảo mật",
        address: "Nơi đăng nhập",
      },
    },
  },
  phone_bind: {
    title: "Liên kết điện thoại",
    success: "Liên kết số điện thoại thành công",
  },
  google_bind: {
    user_center: "Trung tâm cá nhân",
    google_validate: "Liên kết Google Authenticator",
    google_change: "Đổi Google Authenticator",
    tip: "Google Authenticator là công cụ mật khẩu động, nguyên lý hoạt động tương tự xác minh động qua SMS. Sau khi liên kết, cứ mỗi 30 giây tạo một mã xác minh động, mã xác minh dùng cho xác minh an toàn khi đăng nhập, rút tiền, sửa cài đặt bảo mật,...",
    download_title: "Tải APP Google Authenticator",
    download_desc:
      'Người dùng iOS đăng nhập App Store tìm "Authenticator" để tải. Người dùng Android đăng nhập cửa hàng ứng dụng hoặc dùng trình duyệt điện thoại tìm "Google Authenticator" để tải.',
    add_title: "Thêm và sao lưu khóa trong Google Authenticator",
    add_desc:
      "Mở Google Authenticator, quét mã QR bên dưới hoặc nhập thủ công khóa dưới đây để thêm token xác minh.",
    copy_key: "Sao chép khóa",
    add_tip:
      "Khóa dùng để khôi phục Google Authenticator khi đổi hoặc mất điện thoại, trước khi liên kết vui lòng sao lưu khóa dưới đây.",
    change_tip:
      "Sau khi đổi liên kết Google Authenticator, cấm rút tiền và giao dịch OTC trong 24 giờ",
    input_code: "Nhập 6 chữ số mã xác minh trong Google Authenticator",
    google_code_placeholder: "Vui lòng nhập mã Google Authenticator",
    success_tip: "Hoàn tất liên kết",
    success_tip2:
      "Khóa dùng để khôi phục Google Authenticator khi đổi hoặc mất điện thoại, trước khi liên kết vui lòng sao lưu khóa trên.",
    next: "Bước tiếp theo",
    bind_title: "Liên kết xác minh an toàn Google",
    change_title: "Đổi xác minh an toàn Google",
    phone_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    get_code: "Lấy mã xác minh",
    code_placeholder: "Vui lòng nhập mã xác minh",
    email_code_tip: "Nếu không nhận được email, vui lòng kiểm tra hộp thư rác",
    confirm: "Xác nhận",
    cancel: "Hủy",
    success: "Liên kết Google Authenticator thành công",
    change_success: "Đổi Google Authenticator thành công",
  },
  validation_off: {
    title_phone: "Tắt xác minh điện thoại",
    tip_phone:
      "Sau khi tắt xác minh điện thoại, cấm rút tiền và giao dịch OTC trong 24 giờ",
    title_email: "Tắt xác minh email",
    tip_email:
      "Sau khi tắt xác minh email, cấm rút tiền và giao dịch OTC trong 24 giờ",
    title_google: "Tắt Google Authenticator",
    tip_google:
      "Sau khi tắt Google Authenticator, cấm rút tiền và giao dịch OTC trong 24 giờ",
    phone: "Số điện thoại",
    email: "Email",
    phone_placeholder: "Vui lòng nhập số điện thoại",
    phone_code: "Mã xác minh SMS",
    code_placeholder: "Vui lòng nhập mã xác minh",
    email_code: "Mã xác minh email",
    google_code: "Mã Google Authenticator",
    confirm: "Xác nhận",
    phone_off_success: "Đã tắt xác minh điện thoại",
    email_off_success: "Đã tắt xác minh email",
    google_off_success: "Đã tắt Google Authenticator",
    google_lost: "Mất mã Google Authenticator?",
    please_click: "Vui lòng nhấn vào đây",
  },
  validation_on: {
    title_phone: "Bật xác minh điện thoại",
    title_email: "Bật xác minh email",
    title_google: "Bật Google Authenticator",
    phone_open_success: "Bật xác minh điện thoại thành công",
    email_open_success: "Bật xác minh email thành công",
    google_open_success: "Bật Google Authenticator thành công",
  },
  password_recovery: {
    title: "Khôi phục mật khẩu đăng nhập",
    title1: "Đặt lại mật khẩu đăng nhập",
    title3: "Xác nhận mật khẩu của bạn",
    tip3: "Sau khi đổi mật khẩu, cấm rút tiền trong 24 giờ",
    tip: "Sau khi đổi mật khẩu đăng nhập, cấm rút tiền trong 24 giờ",
    tip1: "Ít nhất 8 ký tự và có chứa chữ số và chữ cái",
    tip2: "Đã là người dùng đã đăng ký?",
    btn_login: "Đăng nhập ngay",
    account: "Email",
    account_placeholder: "Vui lòng nhập email",
    mes_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    google_code: "Mã Google Authenticator",
    getCode: "Lấy mã xác minh",
    code_placeholder: "Vui lòng nhập mã xác minh",
    nextStep: "Bước tiếp theo",
    password: "Mật khẩu đăng nhập",
    update_password: "Đổi mật khẩu",
    old_password: "Mật khẩu đăng nhập cũ",
    new_password: "Mật khẩu đăng nhập mới",
    confirm: "Xác nhận mật khẩu",
    password_placeholder: "Vui lòng nhập mật khẩu",
    submit: "Gửi",
    back: "Quay lại",
    success: "Đặt lại mật khẩu thành công",
  },
  password_modify: {
    title: "Đổi mật khẩu đăng nhập",
    tip: "Sau khi đổi mật khẩu đăng nhập, cấm rút tiền và giao dịch OTC trong 24 giờ",
    old_password: "Mật khẩu đăng nhập hiện tại",
    old_password_placeholder: "Vui lòng nhập mật khẩu",
    new_password: "Vui lòng nhập mật khẩu",
    new_password_placeholder: "Vui lòng nhập mật khẩu mới",
    password_confirm: "Xác nhận mật khẩu đăng nhập mới",
    password_confirm_placeholder: "Vui lòng nhập lại mật khẩu",
    mes_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    google_code: "Mã Google Authenticator",
    google_placeholder: "Vui lòng nhập mã Google Authenticator",
    getCode: "Lấy mã xác minh",
    code_placeholder: "Vui lòng nhập mã xác minh",
    submit: "Gửi",
    forget: "Quên mật khẩu đăng nhập",
    success: "Đổi mật khẩu đăng nhập thành công",
  },
  set_trade_password: {
    title: "Đặt mật khẩu giao dịch",
    password_input: "Vui lòng nhập mật khẩu giao dịch",
    password_formatter: "Ít nhất 6 ký tự số hoặc chữ cái hợp lệ",
    password_confirm: "Xác nhận mật khẩu",
    phone_num: "Số điện thoại",
    mes_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    code_placeholder: "Vui lòng nhập mã xác minh",
    getCode: "Lấy mã xác minh",
    submit: "Gửi",
    cancel: "Hủy",
    success: "Đặt mật khẩu giao dịch thành công",
    bind_phone: "Vui lòng liên kết số điện thoại trước",
    email_phone: "Vui lòng liên kết email trước",
    go_bind: "Đi liên kết",
  },
  modify_trade_password: {
    title: "Đổi mật khẩu giao dịch",
    password_input: "Vui lòng nhập mật khẩu giao dịch",
    new_password_input: "Vui lòng nhập mật khẩu giao dịch mới",
    password_formatter: "Ít nhất 6 ký tự số hoặc chữ cái hợp lệ",
    password_confirm: "Xác nhận mật khẩu",
    mes_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    google_code: "Mã Google Authenticator",
    code_placeholder: "Vui lòng nhập mã xác minh",
    google_placeholder: "Vui lòng nhập mã Google Authenticator",
    getCode: "Lấy mã xác minh",
    submit: "Gửi",
    cancel: "Hủy",
    success: "Đổi mật khẩu giao dịch thành công",
  },
  authentication: {
    title: "Xác thực danh tính",
    country: "Quốc tịch",
    country_placeholder: "Vui lòng chọn nơi cư trú",
    name: "Họ tên",
    name_placeholder: "Vui lòng nhập họ tên",
    IDType: "Loại giấy tờ",
    IDCard: "CMND/CCCD",
    passport: "Hộ chiếu",
    ID: "Số giấy tờ tùy thân",
    idNum_placeholder: "",
    submit: "Gửi",
    cancel: "Hủy",
    tip:
      "· Vì sự an toàn tài sản của bạn, cần xác minh danh tính mới có thể thực hiện các thao tác khác<br>" +
      "· Thông tin xác thực một khi đã được xác minh sẽ không thể sửa đổi, vui lòng điền trung thực<br>" +
      "· Sau khi xác thực có thể rút tiền, giao dịch tiền pháp định,...",
    front: {
      title: "Ảnh mặt trước CMND/CCCD của bạn:",
      con:
        "· Vui lòng đảm bảo nội dung ảnh đầy đủ và rõ ràng<br>" +
        "· Hỗ trợ định dạng ảnh jpg/png/jpeg<br>" +
        "· Kích thước ảnh không được vượt quá 2M",
    },
    back: {
      title: "Ảnh mặt sau CMND/CCCD của bạn:",
      con:
        "· Vui lòng đảm bảo nội dung ảnh đầy đủ và rõ ràng<br>" +
        "· CMND/CCCD phải còn trong thời hạn hiệu lực<br>" +
        "· Chỉ hỗ trợ định dạng ảnh jpg/png/jpeg",
    },
    hand: {
      title: "Ảnh bạn cầm giấy tờ:",
      con:
        "· Vui lòng tải lên một ảnh cầm mặt trước giấy tờ kèm chữ ký cá nhân<br>" +
        '· Nội dung chữ ký cá nhân bao gồm <label style="color: #F04C66">ngày</label> viết tay<br>' +
        "· Chỉ hỗ trợ định dạng ảnh jpg/png/jpeg",
    },
    success: "Gửi thành công",
  },
  trade_auth_setting: {
    title: "Xác minh giao dịch",
    tip: "Sau khi tắt, khi đặt lệnh sẽ không cần xác minh mật khẩu nữa",
    open: "Luôn bật",
    close: "Tắt vĩnh viễn",
    submit: "Gửi",
    cancel: "Hủy",
    input_password: "Vui lòng nhập mật khẩu giao dịch",
    success: "Sửa thành công",
  },
  email_bind: {
    title: "Liên kết email",
    email: "Email",
    email_placeholder: "Vui lòng nhập email",
    email_code: "Mã xác minh email",
    getCode: "Lấy mã xác minh",
    code_placeholder: "Vui lòng nhập mã xác minh",
    bind: "Liên kết",
    back: "Quay lại",
    success: "Liên kết email thành công",
  },
  googleBind: {
    google_code: "Mã Google Authenticator",
    code_placeholder: "Vui lòng nhập mã Google Authenticator",
  },
  withdrawal_address_manage: {
    title: "Quản lý địa chỉ rút tiền",
    add_address: "Làm thế nào để thêm địa chỉ rút tiền?",
    coin_type: "Loại tiền",
    network: "Mạng",
    search_coin: "Tìm kiếm loại tiền",
    another_name: "Bí danh địa chỉ",
    another_name_placeholder: "Vui lòng nhập bí danh địa chỉ",
    address: "Địa chỉ rút tiền",
    address_placeholder: "Vui lòng nhập hoặc dán địa chỉ",
    memo_placeholder: "Vui lòng nhập tag",
    memo_tip:
      "Nếu bạn được yêu cầu điền tag địa chỉ (Destination Tag) hoặc ID số hoặc ghi chú, vui lòng điền tại đây; nếu không thì không cần điền.",
    add: "Thêm",
    unbind: "Chưa liên kết",
    phone_code: "Mã xác minh SMS",
    email_code: "Mã xác minh email",
    google_code: "Mã Google Authenticator",
    code_placeholder: "Vui lòng nhập mã xác minh",
    get_code: "Lấy mã xác minh",
    my_withdraw: "Rút tiền của tôi",
    operation: "Thao tác",
    withdraw: "Rút tiền",
    del: "Xóa",
    add_success: "Thêm thành công",
    tip: "Nhắc nhở",
    delete_tip: "Bạn có chắc muốn xóa",
    delete_btn: "Xóa",
    cancel: "Hủy",
    delete_success: "Xóa thành công",
    go_bind: "Đi liên kết",
  },
  receipt_money: {
    title: "Cài đặt thanh toán",
    legal_tender: "Tiền pháp định",
    receiptType: "Phương thức thanh toán",
    bankcard: "Thẻ ngân hàng",
    alipay: "Alipay",
    wechat: "WeChat",
    add: "Thêm",
    news_title:
      'Nhắc nhở tin nhắn mới<label style="color: #A0AAC1; font-size: 16px;">(Chúng tôi sẽ thông báo cho bạn tiến triển mới nhất của đơn hàng OTC qua email hoặc SMS)</label>',
    email_notice: "Thông báo email",
    phone_notice: "Thông báo SMS",
    table_title:
      'Địa chỉ thanh toán của tôi<label style="color: #A0AAC1; font-size: 16px;">(Cùng một phương thức thanh toán chỉ có thể thêm một tài khoản)</label>',
    account: "Tài khoản",
    name: "Họ tên",
    bank_info: "Thông tin ngân hàng",
    operation: "Thao tác",
    edit: "Chỉnh sửa",
    del: "Xóa",
    dialog_title: "Vui lòng điền thông tin thanh toán",
    deposit_bank: "Ngân hàng mở tài khoản",
    bank_address: "Địa chỉ mở tài khoản",
    optional: "Tùy chọn",
    bankcard_num: "Số thẻ ngân hàng",
    confirm_num: "Xác nhận số thẻ",
    input_again: "Vui lòng nhập lại một lần nữa",
    memo: "Thông tin ghi chú",
    trans_password: "Mật khẩu giao dịch",
    input_trans_password: "Vui lòng nhập mật khẩu giao dịch",
    submit: "Xác nhận thông tin",
    alipay_account: "Tài khoản Alipay",
    upload_qr: "Tải lên mã QR",
    wechat_account: "Tài khoản WeChat",
    add_success: "Thêm thành công",
    save: "Lưu",
    edit_success: "Chỉnh sửa thành công",
    tip: "Nhắc nhở",
    delete_tip: "Bạn có chắc muốn xóa",
    delete_btn: "Xóa",
    cancel: "Hủy",
    delete_success: "Xóa thành công",
    needRealName: "Cần xác thực danh tính",
    authentication: "Đi xác thực",
  },
  order_manage: {
    ctc_order: "Đơn hàng coin-coin",
    current_delegation: "Lệnh hiện tại",
    history_delegation: "Lịch sử lệnh",
    coin_type: "Loại tiền",
    all: "Tất cả",
    all_direction: "Tất cả hướng",
    time_start: "Thời gian bắt đầu",
    time_end: "Thời gian kết thúc",
    buy: "Mua vào",
    sell: "Bán ra",
    search: "Tìm kiếm",
    delete_order: "Xóa đơn hàng không hợp lệ",
    time: "Thời gian",
    symbol: "Cặp giao dịch",
    way: "Phương thức",
    direction: "Hướng",
    limit: "Giới hạn giá",
    price: "Giá",
    amount: "Số lượng",
    total: "Tổng giá trị lệnh",
    dk: "Tiêu hao DK",
    status: "Trạng thái",
    had_cancel: "Đã hủy",
    had_complete: "Đã hoàn thành",
    deal_concluded: "Số lượng đã khớp",
    no_deal_concluded: "Chưa khớp",
    operation: "Thao tác",
    order_id: "Mã đơn hàng",
    done_price: "Giá khớp",
    done_amount: "Khối lượng khớp",
    fee: "Phí giao dịch",
    cancel: "Hủy lệnh",
    detail: "Chi tiết",
    delete_record: "Xóa",
    cancel_success: "Hủy thành công",
    delete_success: "Xóa thành công",
    search: "Tìm kiếm",
  },
  asset: {
    overview: "Tổng quan",
    rwa_token: "Token RWA",
    fund: "Tiền",
    estimated_total_assets: "Tổng tài sản ước tính",
    today_profit_loss: "Lãi lỗ hôm nay",
    recharge: "Nạp tiền",
    withdraw: "Rút tiền",
    records: "Ghi chép",
    asset_account: "Tài khoản tài sản",
    asset: "Tài sản",
    usd: "USD",
    us_dollar: "USD",
    hk_dollar: "HKD",
    trade: "Giao dịch",
    no_data: "Chưa có dữ liệu",
    can_not_recharge: "Loại tiền hiện tại tạm thời không hỗ trợ nạp tiền",
    can_not_withdraw: "Loại tiền hiện tại tạm thời không hỗ trợ rút tiền",
    loaded_all: "Đã tải toàn bộ",
    mall_detail: "Chi tiết cửa hàng",
    no_mall_detail: "Chưa có chi tiết cửa hàng",
    available: "Số lượng khả dụng",
    frozen: "Số lượng đóng băng",
    market_trade: "Giao dịch thị trường",
    no_market_data: "Chưa có dữ liệu thị trường",
    exchange_hkd_to_ht: "{coin} Coin có thể mua bằng {base}",
    exchange_record: "Lịch sử đổi {coin}>",
    go_now: "Đến ngay",
  },
  exchangeRecord: {
    title: "Lịch sử đổi {coin}",
    detail_title: "Chi tiết đổi {coin}",
    order_no: "Mã giao dịch",
    transfer_amount: "Số lượng chuyển khoản",
    ht_amount: "Số lượng đổi",
    actual_transfer: "Chuyển khoản thực tế",
    actual_exchange: "Đổi thực tế",
    rate: "Tỷ giá áp dụng",
    recharge_time: "Thời gian nạp",
    transfer_account_info: "Tài khoản chuyển khoản",
    transfer_serial: "Số giao dịch chuyển khoản",
    transfer_time: "Thời gian chuyển khoản",
    review_time: "Thời gian xét duyệt",
    airdrop_time: "Thời gian airdrop",
    reject_reason: "Lý do từ chối",
    status: "Trạng thái",
    status_completed: "Đã hoàn thành",
    status_pending: "Chờ xét duyệt",
    status_rejected: "Đã từ chối",
    no_data: "Chưa có lịch sử đổi",
    loaded_all: "Đã tải xong toàn bộ~",
  },
  exchangeHKD: {
    title: "Đổi {coin}",
    how_to_exchange: "Cách đổi HKD (lấy HT làm ví dụ)",
    step1: "Bước 1: Chuyển khoản HT",
    step2: "Bước 2: Xét duyệt thành công nhận HT",
    step3: "Bước 3: Bán HT nhận USD",
    transfer_amount: "Số lượng chuyển khoản",
    input_amount_placeholder: "Vui lòng nhập số lượng nạp, tối thiểu 100 HKD",
    ht_amount: "Số lượng {coin} có thể nhận",
    rate: "Tỷ giá",
    receipt_account: "Tài khoản nhận tiền",
    account_number: "Tài khoản nhận tiền",
    company: "Công ty mở tài khoản",
    bank: "Ngân hàng mở tài khoản",
    form_title:
      "Để thuận tiện cho việc xét duyệt, vui lòng cung cấp thông tin thẻ ngân hàng chuyển khoản của bạn",
    transfer_account: "Tài khoản chuyển khoản",
    transfer_name: "Tên người chuyển khoản",
    transfer_serial: "Số giao dịch chuyển khoản",
    input_placeholder: "Vui lòng nhập",
    tip1: "Vui lòng đảm bảo số lượng chuyển khoản khớp với số lượng đã nhập, dữ liệu không khớp sẽ dẫn đến nạp tiền thất bại.",
    tip2: "Sau khi hoàn tất chuyển khoản, chờ hệ thống xét duyệt, thường sẽ vào tài khoản trong vòng 24 giờ.",
    tip3: "Trường hợp đặc biệt, có thể liên hệ CSKH, cung cấp mã đơn nạp tiền để được tư vấn.",
    tip4: "HKD bạn chuyển sẽ được quy đổi thành tài sản tương ứng theo tỷ giá và airdrop vào tài khoản tài sản của bạn.",
    complete_transfer: "Hoàn tất chuyển khoản",
    copy_success: "Sao chép thành công",
    submit_fail: "Gửi thất bại",
    success_modal_title: "Lưu ý quan trọng",
    success_modal_content:
      "Sau khi hoàn tất chuyển khoản, bộ phận vận hành sẽ xét duyệt sớm nhất có thể, sau khi xét duyệt thành công sẽ quy đổi thành tài sản tương ứng theo tỷ giá và airdrop vào tài khoản tài sản của bạn, vui lòng chú ý kiểm tra, đường dẫn: Tài sản – Token RWA.",
    success_modal_btn: "Tôi đã hiểu",
    confirm_modal_title: "Xác nhận gửi",
    confirm_modal_content:
      "Vui lòng xác nhận thông tin chuyển khoản đã điền chính xác, sau khi gửi sẽ chuyển sang xét duyệt và không thể sửa đổi. Bạn có xác nhận gửi không?",
    confirm_modal_confirm: "Xác nhận gửi",
    confirm_modal_cancel: "Kiểm tra lại",
    min_amount_tip: "Nạp tối thiểu 100 HKD",
    input_transfer_account: "Vui lòng nhập tài khoản chuyển khoản",
    input_transfer_name: "Vui lòng nhập tên người chuyển khoản",
  },
  user_assets: {
    bankAccountNumber: "Số tài khoản ngân hàng",
    overview: "Tổng quan tài sản",
    total_assets: "Tổng tài sản tài khoản quy đổi",
    ctc_account: "Tài khoản coin-coin",
    little_assets_hide: "Ẩn tài sản nhỏ",
    member_card_title: "Gói thành viên",
    my_card_title: "Thẻ điểm của tôi",
    check_detail: "Xem chi tiết",
    search: "Tìm kiếm loại tiền",
    coin_type: "Loại tiền",
    available_balance: "Số dư khả dụng",
    freeze_balance: "Số dư đóng băng",
    redeem: "Đang chuộc lại",
    valuations: "Định giá",
    operation: "Thao tác",
    recharge: "Nạp coin",
    withdraw: "Rút coin",
    validate_warning:
      "Cần bật ít nhất hai phương thức xác minh, vui lòng đến Trung tâm cá nhân để bật",
    can_not_recharge: "Chức năng nạp coin của loại tiền này tạm thời đóng",
    can_not_withdraw: "Chức năng rút coin của loại tiền này tạm thời đóng",
    record: "Lịch sử giao dịch",
    recharge_address: "Địa chỉ nạp coin",
    blockchain_type: "Loại chuỗi",
    address_type: "Loại địa chỉ",
    new_address: "Địa chỉ mới",
    old_address: "Địa chỉ cũ",
    check: "Xem",
    recharge_record: "Lịch sử nạp coin",
    copy_address: "Sao chép địa chỉ",
    copy_memo: "Sao chép Memo",
    copy_success: "Sao chép thành công",
    copy_error: "Sao chép thất bại",
    min_recharge: "Số tiền nạp tối thiểu：",
    recharge_warning:
      "Khoản nạp nhỏ hơn số tiền tối thiểu sẽ không được ghi có và không thể hoàn lại.",
    memo_warning: "Bắt buộc điền chính xác",
    tip_title: "Lưu ý：",
    tip_con:
      "1.Vui lòng không nạp bất kỳ tài sản nào không phải ETH vào địa chỉ trên, nếu không tài sản sẽ không thể khôi phục.<br>2.Sau khi bạn nạp vào địa chỉ được chỉ định trên, cần X xác nhận mạng mới vào tài khoản.<br>" +
      "3.Địa chỉ nạp của bạn sẽ không thường xuyên thay đổi, có thể nạp lặp lại; nếu có thay đổi, chúng tôi sẽ cố gắng thông báo cho bạn qua thông báo trên website hoặc email.<br>" +
      "4.Vui lòng đảm bảo máy tính và trình duyệt an toàn, tránh thông tin bị chỉnh sửa hoặc rò rỉ.",
    choice_address: "Chọn địa chỉ rút coin",
    choice_address_placeholder: "Vui lòng chọn địa chỉ rút coin",
    withdraw_record: " Lịch sử rút coin",
    add_address: "Thêm địa chỉ mới",
    withdraw_amount: "Số lượng rút coin",
    available: "Số lượng khả dụng：",
    withdraw_amount_placeholder: "Vui lòng nhập số lượng rút coin",
    withdraw_amount_placeholder1: "Số lượng rút coin tối thiểu là",
    withdraw_amount_placeholder2: "Tối đa không vượt quá",
    min_withdraw: "Số tiền rút coin tối thiểu là",
    withdraw_warning:
      "Ưu tiên trừ từ số dư, khi số dư không đủ thì trừ từ số lượng rút coin",
    withdraw_success: "Rút tiền thành công",
    trans_password: "Mật khẩu giao dịch",
    trans_password_placeholder: "Vui lòng nhập mật khẩu giao dịch",
    buy_member:
      "Bạn sắp mua gói thành viên, sau khi mua gói thành viên sẽ được hưởng quyền lợi thành viên, vui lòng xác nhận số dư tài khoản coin-coin đủ trước",
    buy_amount: "Số lượng mua",
    should_pay: "Số tiền phải trả",
    pay_confirm_title: "Xác nhận thanh toán",
    pay_confirm: "Xác nhận thanh toán",
    pay_success: "Mua thành công",
    available_not_enough: "Số dư không đủ",
    need_whole_number: "Giá trị nhập phải là số nguyên dương",
    cancel: "Hủy",
    phone_code: "Mã xác minh SMS",
    phone_code_placeholder: "Vui lòng nhập mã xác minh SMS",
    email_code: "Mã xác minh email",
    email_code_placeholder: "Vui lòng nhập mã xác minh email",
    get_code: "Lấy mã xác minh",
    phone_bind: "Liên kết số điện thoại",
    email_bind: "Liên kết email",
    google_code: "Mã Google Authenticator",
    google_code_placeholder: "Vui lòng nhập mã Google Authenticator",
    memo_tip:
      '·Điền sai, thiếu Memo có thể dẫn đến mất tài sản, vui lòng kiểm tra kỹ<br><label class="font_color_red">·Bắt buộc điền khi chuyển vào địa chỉ sàn giao dịch</label>',
    memo_placeholder: "Vui lòng nhập MEMO",
    actual: "Số lượng thực nhận：",
    fee: "Phí giao dịch：",
    withdraw_btn: "Rút coin",
    my_dk: "Thẻ điểm của tôi",
    available_dk: "Số dư thẻ điểm",
    buy_dk: "Mua thẻ điểm",
    dk_desc:
      "Thẻ điểm là thẻ nạp phí giao dịch do nền tảng RWA ra mắt, 1 thẻ điểm (dk) = phí giao dịch tương đương 1 USDT.",
    buy_placeholder: "Vui lòng nhập số lượng mua",
    buy_btn: "Mua",
    min_buy_amount: "Số tiền mua tối thiểu",
    min_amount_warning: "Số tiền mua không được ít hơn số tiền tối thiểu",
    available_usdt: "USDT khả dụng",
    api: {
      tips_val_1:
        "Khóa riêng tư cho phép bạn truy cập tài khoản và thực hiện lệnh giao dịch qua API theo giao thức mở RWAEx, khóa chúng tôi cung cấp cho bạn rất quan trọng, vui lòng bảo quản cẩn thận.",
      setting: "Cài đặt API",
      check_document: "Xem tài liệu API",
      attentionVal1:
        "1. Nền tảng này cung cấp dịch vụ giao diện API mạnh mẽ, bao gồm truy vấn dữ liệu thị trường, giao dịch,... Vui lòng tham khảo tài liệu API để sử dụng. Tên miền thương gia: openapi.rwa.ltd",
      attentionVal2: "2. Mỗi người dùng có thể tạo tối đa 5 bộ khóa API.",
      attentionVal3:
        "3.Không công khai khóa API của bạn để tránh tổn thất kinh tế. Vì lý do an toàn, chúng tôi khuyên bạn nên liên kết địa chỉ IP với khóa API của mình.",
      attentionVal4:
        "4. Mỗi khóa API hỗ trợ liên kết tối đa 5 địa chỉ IP. Dùng dấu phẩy để phân tách nhiều địa chỉ IP.",
      attention:
        '<label style="color: #F04C66">Lưu ý:</label><br>· Chúng tôi cung cấp API REST và WebSocket, có thể tham khảo tài liệu API.<br>· Mỗi người dùng có thể tạo tối đa 10 cặp khóa API.<br>' +
        "· Đối với API giao dịch, mỗi IP giới hạn 1000 lần truy cập mỗi phút, vượt quá 1000 lần sẽ bị khóa 1 giờ, tự động mở khóa sau một giờ.<br>" +
        "· Đối với API giao dịch, mỗi API giới hạn 60 lần truy cập mỗi giây, hơn 60 yêu cầu trong một giây sẽ bị coi là không hợp lệ.<br>· Giao diện K-line chỉ có thể yêu cầu dữ liệu một lần mỗi giây.<br>" +
        "· Nếu có bất kỳ vấn đề nào trong quá trình sử dụng, vui lòng tham gia nhóm QQ 710574280, chúng tôi sẽ giải đáp uy tín nhất cho bạn.",
      add: "Thêm API mới",
      fill_info: "Điền thông tin khóa API",
      role_api: "Quyền khóa API",
      api_check:
        "Truy vấn tài sản: Truy vấn thông tin tài khoản và tình trạng tài sản",
      api_trade: "Lệnh giao dịch: Đặt lệnh, hủy, truy vấn đơn hàng giao dịch",
      remarks: "Ghi chú",
      remarks_placeholder: "Ghi chú tên API",
      bind_ip: "Liên kết địa chỉ IP (tùy chọn)",
      remark_placeholder: "Ghi chú tên API",
      bind_placeholder: 'Có thể thêm nhiều, phân tách bằng ","',
      create_key: "Tạo khóa API",
      my_key: "Khóa API của tôi",
      id: "STT",
      operation: "Thao tác",
      alert_title: "Khóa API",
      show_once: "Chỉ hiển thị một lần, nếu quên vui lòng tạo lại",
      visit_key: "Khóa truy cập API (Access Key)",
      private_key: "Khóa riêng tư API (Secret Key)",
      copy: "Sao chép",
      important_info:
        "Lưu ý quan trọng:<br>Khóa riêng tư cho phép bạn truy cập tài khoản và thực hiện lệnh giao dịch qua API theo giao thức mở RWAEx, " +
        "khóa chúng tôi cung cấp cho bạn rất quan trọng, vui lòng bảo quản cẩn thận.",
      confirm: "Xác nhận",
      delete_api: "Xóa",
      delete_confirm: "Xác nhận xóa",
      cancel: "Hủy",
      delete_success: "Xóa thành công",
    },
    web_record: {
      tabTypeValue1: "Token RWA",
      tabTypeValue2: "Tiền",
      membershipPackage: "Gói thành viên",
      searchTitle: "Tài khoản",
      info: "Thông tin",
      transaction: "Giao dịch",
      title: "Lịch sử giao dịch",
      recharge: "Nạp coin",
      recharge2: "Nạp tiền",
      rechargeAddress: "Địa chỉ nạp tiền",
      rechargeTips:
        "Khi nạp tiền, vui lòng kiểm tra kỹ thông tin nạp tiền để tránh mất tài sản do thông tin sai",
      rechargeTips1: "Vui lòng đảm bảo số lượng nạp không nhỏ hơn",
      rechargeTips2: "không lớn hơn",
      rechargeTips3: "tránh mất tài sản do số lượng sai",
      withdraw: "Rút coin",
      ctc: "Coin-coin",
      buy: "Mua vào",
      fiatCurrency: "Tiền pháp định",
      sell: "Bán ra",
      other: "Khác",
      search: "Tìm kiếm loại tiền",
      input_coin: "Nhập loại tiền",
      time: "Thời gian",
      type: "Loại-Loại tiền",
      amount: "Số lượng",
      status: "Trạng thái",
      success: "Thành công",
      fail: "Thất bại",
      status_pending: "Chờ duyệt",
      complete: "Đã hoàn thành",
      status_applied: "Đã đăng ký",
      status_checked: "Đã xét duyệt",
      status_send: "Đã phát",
      status_confirm: "Đang xác nhận",
      status_withdraw: "  Rút tiền thành công",
      status_refused: "Đã từ chối",
      status_cancel: "Đã hủy",
      recharge_address: "Địa chỉ nạp coin",
      withdraw_address: "Địa chỉ rút coin",
      operation: "Thao tác",
      cancel: "Hủy",
      cancel_success: "Hủy thành công",
      check_detail: "Xem chi tiết",
      account_balance: "Số dư tài khoản",
      wallet_handle_time: "Thời gian xử lý ví",
      trade_id: "ID giao dịch",
      desc: "Mô tả",
      fee: "Phí giao dịch",
      dk: "Tiêu hao DK",
      dk_deduct: "Khấu trừ thẻ thành viên",
      rebate: "Hoàn phí",
      burst_block: "Nổ khối",
      block_detail: "Chi tiết nổ khối",
      prize: "Số tiền trúng thưởng",
      prize_order: "Mã đơn trúng thưởng",
      prize_tip:
        "Chúc mừng bạn đã trúng thưởng khi tham gia hoạt động nổ khối, phần thưởng sẽ được tự động phát vào tài khoản coin-coin của bạn trong vòng 24 giờ, vui lòng chú ý thay đổi số dư tài khoản.",
      block_detail_h2:
        "Kính gửi người dùng, chúc mừng bạn nổ khối thành công và chia sẻ giải thưởng bốn hạng",
      transfer: "Chuyển khoản",
      mall: "Cửa hàng",
      coin_type: "Loại tiền",
      flow_type: "Loại",
      all: "Tất cả",
      mall_pay: "Thanh toán cửa hàng",
      mall_distribute: "Phân phối cửa hàng",
      view_btn: "Xem",
      trade_info_title: "Thông tin giao dịch",
      exchange_pay: "Thanh toán",
      exchange_get: "Nhận",
      exchange_rate: "Tỷ giá",
      confirm_num: "Số xác nhận",
      wallet_address: "Địa chỉ ví",
      explain: "Mô tả",
      copy_success: "Sao chép thành công",
      copy_fail: "Sao chép thất bại",
      coin: "Loại tiền",
      recharge_amount: "Số lượng nạp",
      trade_hash: "Hash giao dịch",
      init_time: "Thời gian khởi tạo",
      arrive_time: "Thời gian đến",
      security_check: "Kiểm tra bảo mật",
      review_pass: "Đã vượt qua",
      review_risk: "Rủi ro cao",
      arrived_title: "Đã đến",
      arrived_desc: "Quỹ đã được ghi vào số dư khả dụng",
      frozen_title: "Quỹ bị đóng băng",
      frozen_desc: "Phát hiện liên kết địa chỉ rủi ro cao",
      view_asset_btn: "Xem số dư tài sản",
      fail_tips: "Nếu có thắc mắc, vui lòng liên hệ hỗ trợ",
      completed: "Đã hoàn thành",
    },
  },
  rechargeCoins: {
    coin_type: "Loại tiền",
    chain_type: "Loại chuỗi",
    recharge_address: "Địa chỉ nạp tiền",
    notice: "Lưu ý",
    notice_content1:
      "Vui lòng đảm bảo loại chuỗi bạn chọn khớp với nền tảng chuyển ra, nếu không có thể dẫn đến mất tài sản",
    notice_content2:
      "Vui lòng điền đúng địa chỉ nạp tiền, địa chỉ sai sẽ dẫn đến tài sản không thể khôi phục",
    copy_success: "Sao chép thành công",
    copy_fail: "Sao chép thất bại",
  },
  sellOrder: {
    search_placeholder: "Tìm kiếm mã đơn hàng",
    all: "Tất cả",
    completed: "Đã hoàn thành",
    pending_distribution: "Chờ phân phối",
    pending_payment: "Chờ thanh toán",
    cancelled: "Đã hủy",
    order_id: "Mã đơn hàng",
    subscription_shares: "Số phần đăng ký mua",
    payment_price: "Giá thanh toán",
    total_payment: "Tổng số tiền thanh toán",
    order_time: "Thời gian đặt hàng",
    cancel_order: "Hủy đơn hàng",
    go_pay: "Đi thanh toán",
    load_complete: "Đã tải xong toàn bộ",
    pay: "Thanh toán",
    pay_amount: "Số tiền thanh toán",
    pay_method: "Phương thức thanh toán",
    balance: "Số dư",
    trade_password: "Mật khẩu giao dịch",
    password_placeholder: "Vui lòng nhập mật khẩu giao dịch",
    confirm_pay: "Xác nhận thanh toán",
    pay_success: "Thanh toán thành công",
    confirm: "Xác nhận",
    cancel_tip: "Nhắc nhở",
    cancel_confirm: "Bạn có chắc muốn hủy đơn hàng này?",
    cancel_success: "Hủy thành công",
    cancel_fail: "Hủy thất bại",
    pay_fail: "Thanh toán thất bại",
    password_required: "Vui lòng nhập mật khẩu giao dịch",
    status_completed: "Đã hoàn thành",
    status_pending_distribution: "Chờ phân phối",
    status_pending_payment: "Chờ thanh toán",
    status_cancelled: "Đã hủy",
    recharge: "Nạp tiền",
    set_password: "Cài đặt",
    insufficient_balance: "Số dư không đủ",
    cancel: "Hủy",
  },
  sellOrderDetails: {
    payment_countdown: "Đếm ngược thanh toán",
    subscription_shares: "Số phần đăng ký mua",
    subscription_amount: "Số lượng đăng ký mua",
    issue_price: "Giá phát hành",
    total_payment: "Tổng số tiền thanh toán",
    order_time: "Thời gian đặt hàng",
    distribution_time: "Thời gian phân phối",
    transaction_time: "Thời gian giao dịch",
    order_no: "Mã đơn hàng",
    copy: "Sao chép",
    asset_tip: "Xem tài sản của tôi",
    cancel_order: "Hủy đơn hàng",
    go_pay: "Đi thanh toán",
    back_to_order_list: "Quay lại danh sách đơn hàng",
  },
  withdrawCoins: {
    coin_type: "Loại tiền",
    chain_type: "Loại chuỗi",
    address: "Địa chỉ rút tiền",
    withdraw_amount: "Số lượng rút coin",
    available: "Số lượng khả dụng",
    fee: "Phí giao dịch",
    notice: "Lưu ý",
    notice_content1:
      "Vui lòng đảm bảo loại chuỗi bạn chọn khớp với nền tảng chuyển vào, nếu không có thể dẫn đến mất tài sản",
    notice_content2:
      "Vui lòng điền đúng địa chỉ rút tiền, địa chỉ sai sẽ dẫn đến tài sản không thể khôi phục",
  },
  confirmBuy: {
    title: "Xác nhận mua",
    subscription_shares: "Số phần đăng ký mua",
    available: "Số phần có thể đăng ký mua",
    shares: "phần",
    per_share: "phần",
    subscription_value: "Giá trị đăng ký mua",
    issue_price: "Giá phát hành",
    payment_total: "Tổng số tiền thanh toán",
    payment: "Loại tiền thanh toán",
    pay_from: "Thanh toán từ tài khoản tài sản",
    balance: "Số dư tài sản",
    recharge: "Đi nạp tiền",
    cancel: "Hủy",
    confirm_buy: "Xác nhận mua",
    trade_password: "Vui lòng nhập mật khẩu giao dịch",
    confirm_pay: "Xác nhận thanh toán",
    processing: "Đang xử lý...",
    enter_password: "Vui lòng nhập mật khẩu giao dịch",
    pay_fail: "Thanh toán thất bại",
    order_create_fail: "Tạo đơn hàng thất bại",
    pay_success: "Thanh toán thành công",
    tip: "Nhắc nhở",
    exceeded: "Vượt quá giới hạn mua",
    exceeded_tip: "Đã vượt quá số lượng mua tối đa",
    insufficient_balance: "Số dư không đủ",
    unpaid_order_exists: "Bạn có đơn hàng chưa thanh toán",
    goto: "Đi xem",
  },
  wallet: {
    charging: {
      amount: "Số lượng nạp",
      amount_placeholder: "Vui lòng nhập số lượng nạp",
      hkd_account: "Vui lòng chuyển đô la Hồng Kông vào tài khoản dưới đây",
      receive_account: "Tài khoản nhận tiền",
      company: "Công ty mở tài khoản",
      bank: "Ngân hàng mở tài khoản",
      bank_info:
        "Để thuận tiện cho việc xét duyệt, vui lòng cung cấp thông tin thẻ ngân hàng chuyển khoản của bạn",
      transfer_account: "Tài khoản chuyển khoản",
      name: "Tên người chuyển khoản",
      transaction_no: "Số giao dịch chuyển khoản",
      input_placeholder: "Vui lòng nhập",
      confirm_tip:
        "Sau khi hoàn tất chuyển khoản vui lòng nhấn hoàn tất chuyển khoản",
      complete: "Hoàn tất chuyển khoản",
      tip1: "Vui lòng đảm bảo số lượng vào tài khoản khớp với số lượng đã nhập, dữ liệu không khớp sẽ dẫn đến nạp tiền thất bại",
      tip2: "Sau khi hoàn tất chuyển khoản, chờ hệ thống xét duyệt, thường sẽ vào tài khoản trong vòng 24 giờ.",
      tip3: "Trường hợp đặc biệt, có thể liên hệ nhân viên CSKH, cung cấp mã đơn nạp tiền để được tư vấn.",
      amount_required: "Vui lòng nhập số lượng nạp",
      account_required: "Vui lòng nhập tài khoản chuyển khoản",
      name_required: "Vui lòng nhập tên người chuyển khoản",
      submit_success:
        "Đã gửi chuyển khoản, sau khi xét duyệt thành công sẽ vào tài khoản.",
      submitted_title: "Đã gửi",
      submitted_desc:
        "Đã gửi chuyển khoản, vui lòng chờ xét duyệt, sau khi thành công sẽ vào tài khoản.",
      view_records: "Xem lịch sử nạp coin",
    },
  },
  burst: {
    header: {
      h1: "Số nổ khối được công bố đúng 8 giờ tối mỗi ngày<br>7 chữ số cuối của mã đơn hàng của bạn trùng với số nổ khối, tức là trúng giải lớn!",
      h3: "Do sàn giao dịch RWA sáng tạo lần đầu, số nổ khối tuyệt đối công bằng công chính",
      four_digit: "Giải bốn số đã tích lũy:",
      seven_digit: "Giải bảy số đã tích lũy:",
      nav1: "Cặp khóa công/riêng kỳ này",
      nav2: "Xác minh quan hệ khóa công/riêng",
      nav3: "Nhấn để xem quy tắc hoạt động nổ khối",
    },
    q1: {
      title: "1.Nổ khối là gì?",
      con:
        "Cách chơi này do sàn giao dịch RWA sáng tạo lần đầu, sàn giao dịch RWA sẽ lấy 30% doanh thu phí giao dịch đưa vào giải thưởng, " +
        "nếu 4 hoặc 7 chữ số Ả Rập cuối của mã đơn hàng giao dịch coin-coin do giao dịch của người dùng tạo ra khớp với 4 hoặc 7 chữ số cuối của số nổ khối kỳ đó, thì nổ khối thành công. " +
        "Chia sẻ giải thưởng theo quy tắc hoạt động, phần thưởng sẽ được tự động phát trong vòng 24 giờ.",
      table_title: "Dữ liệu tạo khối EOS theo thời gian thực",
      time: "Thời gian tạo khối",
      block_num: "Số khối",
      hash: "Giá trị hash",
      link: 'Dữ liệu được cung cấp bởi <a href="https://eospark.com/" target="_blank" style="color: #42CB83;">eospark.com</a>',
    },
    q2: {
      title: "2.Làm thế nào để tham gia nổ khối?",
      con:
        "Tổng quỹ giải thưởng là 30% doanh thu phí giao dịch của sàn giao dịch RWA, trong đó 20% đưa vào giải bảy số, 10% đưa vào giải bốn số. " +
        'Trong vòng 24 giờ, các đơn hàng có giá trị giao dịch đạt 10 USDT của người dùng tại khu giao dịch coin-coin đều có thể tham gia hoạt động "nổ khối". Người dùng khớp với 4 chữ số cuối của giá trị hash chia sẻ quỹ giải bốn số, ' +
        "người dùng khớp với 7 chữ số cuối của giá trị hash chia sẻ quỹ giải bảy số.",
      trade_now: "Giao dịch ngay",
    },
    q3: {
      title: "3.Phần thưởng được phát như thế nào?",
      con: "Tự động quay số vào lúc 20:00:00 (UTC+8) mỗi ngày, giải thưởng sẽ được phát vào tài khoản coin-coin của người dùng trong vòng 24 giờ, và sẽ thông báo cho người dùng trúng thưởng qua SMS.",
      table_title1: "Công bố thông tin quay số các kỳ trước",
      table_title2: "Đơn hàng hợp lệ của tôi",
      time: "Ngày",
      key: "Cặp khóa công/riêng",
      hash: "Giá trị hash",
      reward: "Giá trị quay số",
      publicKey: "Khóa công",
      privateKey: "Khóa riêng",
      orderNum: "Mã đơn hàng",
      status: "Trạng thái",
      rewardMoney: "Số tiền trúng thưởng",
      drawn_prize: "Trúng thưởng",
      drawn_no_prize: "Không trúng thưởng",
    },
    alert: {
      title_key: "Cặp khóa công riêng kỳ này",
      publicKey: "Khóa công",
      privateKey: "Khóa riêng",
      not_yet_published: "Tạm chưa công bố (công bố lúc 20:00:00 chiều)",
      back: "Quay lại",
      title_rules: "Quy tắc hoạt động nổ khối",
      rules_con:
        "Chọn một cặp khóa công riêng, công bố khóa công ra ngoài vào lúc 8:00:00 sáng (UTC+8) mỗi ngày.<br><br>" +
        'Mạng chính EOSIO tạo ra hai khối mỗi giây, chúng tôi lấy hai khối được tạo ra vào đúng 20:00:00 (UTC+8) trong ngày, <label style="color: #A0AAC1">' +
        "4 chữ số cuối của khối trước, 7 chữ số cuối của khối sau, cộng lần lượt với 4 chữ số cuối, 7 chữ số cuối của khóa riêng, lấy 4 chữ số cuối, 7 chữ số cuối của kết quả cuối cùng." +
        " (Nếu có chữ cái thì bỏ qua, nếu kết quả cộng vượt quá 4, 7 chữ số, chỉ lấy 4 chữ số cuối và 7 chữ số cuối của kết quả cộng.)</label><br><br>" +
        "Nếu mã đơn hàng giao dịch coin-coin của người dùng đáp ứng giá trị giao dịch 10 USDT, và 4 chữ số cuối hoặc 7 chữ số cuối trùng với số nổ khối, thì chia sẻ tiền thưởng của giải.<br><br>" +
        '<label style="color: #A0AAC1;"> Ví dụ, ngày 2 tháng 7 năm 2019 lúc 8 giờ sáng công bố khóa công:<br>EOS7wW1bAdMqVERBvFShcADXpLhTrs5oWSkzK7vkwosSvrqP5e2nq <br><br>' +
        "Lúc 20 giờ chiều công bố giá trị hash của khối: <br>Trước：03f9bf71d0e75e131fd75508091c0c64609a3ff9af71be496728e97ef" +
        '<label style="color: #42CB83">953</label>f<label><label style="color: #42CB83">3</label>ba</label>' +
        '<br>Sau：03f9bf727c3b3be0f9f6c36f8d1bebc0720fe2e65fd4d7f<label style="color: #42CB83">0</label>e<label style="color: #42CB83">88</label>cf' +
        '<label style="color: #42CB83">6</label>bf<label style="color: #42CB83">21</label>d<label style="color: #42CB83">4</label>eebb<br>' +
        'Khóa riêng：5JFyWm2Dx8ywKwEC2bvSUEnZE<label style="color: #42CB83">1</label>rGSCPT<label style="color: #42CB83">18</label>ijAwarJKrp' +
        '<label style="color: #42CB83">579</label>Qe<label style="color: #42CB83">6</label>k<br><br>' +
        "Giá trị quay số là： <br>9533+5796=15329<br>0886214+1185796=2072010<br><br>Nếu số cuối mã đơn hàng của người dùng là 5329 hoặc 2072010, thì đáp ứng điều kiện trúng thưởng.</label><br><br><br>" +
        "Lưu ý quay số:<br>Người dùng cần biết rằng, việc tạo khóa công riêng sử dụng thuật toán mã hóa bất đối xứng RSA, có thể xuất khóa công từ khóa riêng, nhưng quá trình suy diễn này không thể đảo ngược, do đó mỗi khi tạo ra một khóa công, " +
        "chắc chắn có khóa riêng tương ứng, và không thể thay đổi.<br><br>Mạng chính EOSIO tạo ra hai khối mỗi giây, giá trị hash của khối được tạo ngẫu nhiên, không thể bị con người kiểm soát." +
        "<br><br>Công bố khóa công trước, nghĩa là khóa riêng không thể thay thế; chọn giá trị hash làm yếu tố quay số, nghĩa là không thể bị con người kiểm soát. Hoạt động này quay số công bằng, công chính, hỗ trợ người dùng tra cứu xác minh.",
    },
  },
  notification: {
    system: {
      nav: "Thông báo hệ thống",
      login_check: "Đăng nhập để xem",
      mark_all: "Đánh dấu tất cả đã đọc",
      mark_success: "Đánh dấu thành công",
    },
  },
  partner: {
    h1Title1: "Tham gia chương trình thành viên RWA",
    h1Title2: "Hoàn phí giới thiệu liên tục & Hoạt động ưu đãi có thời hạn",
    spanVal: "Làm thế nào để dễ dàng kiếm hoàn tiền?",
    spanVal01: "Đăng ký đăng nhập RWA.LTD",
    spanVal02: "Dùng email để đăng ký đăng nhập",
    spanVal03: "Mua gói thành viên để trở thành thành viên",
    spanVal04: "Thanh toán 100USD/782HKD/100USDT",
    spanVal05: "Lấy và chia sẻ liên kết mời",
    spanVal06: "Mời bạn bè của bạn đăng ký",
    spanVal07: "Nhận phần thưởng thành viên",
    spanVal08: "Mời nhiều bạn bè hơn, nhận phần thưởng hoàn tiền",
    becomeMember: "Trở thành thành viên",
    memberTips:
      "Bạn chưa là thành viên, mua thẻ điểm 100USD để trở thành thành viên sàn giao dịch, hưởng quyền lợi thành viên",
    memberTips1: "Trở thành thành viên nền tảng ngay",
    memberTips2: "Mời nhiều bạn bè hơn, kiếm nhiều phần thưởng hơn",
    memberTips3: "Mời nhiều bạn bè hơn, kiếm nhiều phần thưởng hơn",
    memberTips4:
      "Bạn sắp mua gói thành viên, sau khi mua gói thành viên sẽ được hưởng quyền lợi thành viên, vui lòng xác nhận số dư tài khoản giao ngay đủ trước",
    memberTips5: "Gói thành viên RWA.LTD",
    memberTips6:
      "Trở thành thành viên sàn giao dịch, nhận thưởng hoàn phí giao dịch 40%",
    memberTips7: "Chúc mừng bạn đã trở thành thành viên",
    memberTips8: "Mời bạn bè ngay, nhận hoàn phí giao dịch!",
    memberTips9: "Bạn đã trở thành thành viên nền tảng",
    dk_balance: "Số dư DK: ",
    dk_detail_title: "Chi tiết DK",
    dk_type: "Loại",
    dk_type_fee: "Khấu trừ phí",
    dk_type_buy: "Mua gói thành viên",
    memberWorth: "Giá trị",
    memberPay: "Cần thanh toán",
    memberNowPay: "Thanh toán ngay",
    memberVip: "Cấp bậc",
    shareList: "Dữ liệu mời",
    shareListTips:
      "Phần thưởng khi mời bạn bè mở thành viên được phát theo thời gian thực, phát trực tiếp vào ví tài sản USD, vui lòng chú ý nhận.",
    rebateRatio: "Tỷ lệ hoàn phí",
    cumulativeRebate: "Hoàn phí tích lũy",
    cumulativeCashback: "Hoàn tiền tích lũy",
    cumulativeCashback1: "Số người mời tích lũy (mời trực tiếp)",
    shareTab1: "Bảng xếp hạng mời",
    shareTab2: "Lịch sử mời",
    shareTab3: "Lịch sử hoàn phí",
    questionsTitle: "Câu hỏi thường gặp",
    questionsVal1: "Có giới hạn hoàn phí không?",
    questionsVal2:
      "Có. Vì lý do tuân thủ, RWA.LTD đặt ra giới hạn tổng hoàn phí và hoàn tiền hàng tháng là 1000USD cho mỗi thành viên.",
    questionsVal3:
      "Sau khi trở thành thành viên, làm thế nào để nhận hoàn phí giới thiệu?",
    questionsVal4:
      "A mời bạn B đăng ký trên sàn giao dịch. Khi B giao dịch trên sàn, A có thể nhận 40% hoàn phí giao dịch. Nếu B lại mời C đăng ký, khi C giao dịch, B có thể nhận 40% hoàn phí giao dịch, đồng thời A có thể nhận 10% hoàn phí giao dịch.",
    questionsVal5:
      "Sau khi trở thành thành viên, làm thế nào để nhận hoàn tiền giao dịch (cashback)?",
    questionsVal6:
      "Nếu bạn B mà A mời trở thành thành viên sàn giao dịch, A có thể nhận hoàn tiền 20USD/USDT. Nếu B lại mời C trở thành thành viên sàn giao dịch, thì B có thể nhận hoàn tiền 20USD/USDT, còn A có thể nhận hoàn tiền 10USD/USDT.",
    questionsVal61: "Chương trình thành viên có giới hạn thời gian không?",
    questionsVal62:
      "Tính đến hiện tại, chương trình này chưa đặt giới hạn thời gian. Nhưng RWA.LTD bảo lưu quyền tự quyết định chỉnh sửa, tạm dừng hoặc chấm dứt chương trình này bất cứ lúc nào mà không cần thông báo trước.",
    questionsVal7: "Sau khi trở thành thành viên có những quyền lợi gì?",
    questionsVal8:
      "Sau khi trở thành thành viên, bạn sẽ được hưởng các quyền lợi sau:",
    questionsVal81:
      "1.Hoàn tiền giới thiệu: Sau khi bạn bè cấp dưới mua gói thành viên, bạn có thể nhận phần thưởng hoàn tiền.",
    questionsVal82:
      "2.Giảm phí giao dịch: Trong 365 ngày kể từ ngày mua, phí giao dịch nền tảng được hưởng giảm 50%.",
    questionsVal83:
      "3.Phí thành viên 100USD có thể khấu trừ 50% phí giao dịch, trong thời gian khấu trừ, do thành viên được hưởng ưu đãi giảm 50% phí, phí cần trả thêm chỉ còn 25% chi phí ban đầu.",
    header_con1: "Chia sẻ phúc lợi nền tảng với người dùng",
    header_con2: "Chương trình đối tác triệu phú",
    header_con3: "Đang tuyển thành viên",
    not_login: "Bạn chưa đăng nhập",
    please_login: "Vui lòng đăng nhập trước",
    need_set_password: "Cần đặt mật khẩu giao dịch",
    set_now: "Đi cài đặt",
    not_yet_member: "Bạn chưa là thành viên",
    not_yet_partner: "Bạn chưa là đối tác",
    update_now: "Nâng cấp ngay",
    is_vip: "Xin chào, cấp bậc hiện tại của bạn là",
    my_reward: "Thu nhập của tôi quy đổi (USDT)",
    rwa_register: "Người dùng đã đăng ký",
    rwa_member: "Thành viên RWA",
    rwa_partner: "Đối tác RWA",
    rwa_diamond: "Đối tác kim cương RWA",
    create_poster: "Tạo poster",
    my_invite_code: "Mã mời của tôi",
    share_invite_code: "Chia sẻ liên kết mời",
    my_invite_code_url: "Liên kết mã mời của tôi",
    copy_success: "Sao chép thành công",
    copy_fail: "Sao chép thất bại",
    invite_reward_withdraw: "Hoàn tiền thẻ điểm",
    second_invite_reward_withdraw: "Hoàn tiền thẻ điểm cấp hai",
    invite_reward_fee: "Tỷ lệ hoàn phí giao dịch",
    second_invite_reward_fee: "Tỷ lệ hoàn phí giao dịch cấp hai",
    invite_amount: "Số người mời",
    invite_up_member: "Thành viên cấp một của tôi",
    invite_upup_member: "Thành viên cấp hai của tôi",
    volume_24h: "Số giao dịch 24H",
    reward_withdraw_24h: "Đã hoàn phí 24H",
    reward_fee_total: "Hoàn phí giao dịch của tôi",
    reward_withdraw_total: "Hoàn tiền mời của tôi",
    reward_cash_total: "Số tiền hoàn",
    title1: "1. Sàn giao dịch theo mô hình thành viên là gì?",
    table_title1:
      "Quyền lợi thành viên và quy tắc hoàn phí của sàn giao dịch RWA",
    table_title2: "Yêu cầu các cấp thành viên của sàn giao dịch RWA",
    dk_reward: "Hoàn tiền thẻ điểm",
    trans_reward_fee: "Hoàn phí giao dịch",
    up_trans_reward_fee: "Hoàn phí giao dịch cấp hai",
    level: "Cấp bậc",
    up_dk_reward: "Hoàn tiền thẻ điểm cấp hai",
    fee_discount: "Giảm phí giao dịch",
    need: "Cần",
    no_need: "Không cần",
    real_name: "Xác thực danh tính",
    buy_dk: "Mua thẻ điểm",
    need_invite_amount: "Yêu cầu số người mời",
    need_trans_money: "Yêu cầu giá trị giao dịch",
    con1:
      'Thành viên của sàn giao dịch RWA có thể hưởng nhiều quyền lợi của nền tảng, còn định vị của nền tảng là bên cung cấp dịch vụ kỹ thuật sàn giao dịch, nền tảng sẽ nhượng lợi nhuận của sàn giao dịch cho thành viên, để thành viên hưởng nhiều thu nhập hơn, trở thành "ông chủ" của sàn giao dịch. <br>' +
      "Nền tảng RWA thông qua mô hình thành viên thu hút người dùng chất lượng tham gia cộng đồng, áp dụng cách thức cùng xây dựng cộng đồng và chia sẻ lợi ích cho thành viên để tạo nên cộng đồng RWA mạnh mẽ, tiến thêm một bước tạo nên sàn giao dịch theo mô hình thành viên số một thế giới.",
    example1:
      'Ví dụ:<br><p style="color: #222A55; font-size: 16px;">1) A là người dùng đã đăng ký của sàn giao dịch RWA, vậy A làm thế nào để trở thành thành viên sàn giao dịch?</p>' +
      "A muốn trở thành thành viên sàn giao dịch, chỉ cần trực tiếp mua thẻ điểm 100USDT, là có thể trở thành thành viên sàn giao dịch." +
      '<p style="margin-top: 30px;color: #222A55; font-size: 16px;">2) Sau khi trở thành thành viên, A làm thế nào để nhận hoàn phí giới thiệu?</p>' +
      "A mời bạn B đăng ký sàn giao dịch RWA, khi B giao dịch trên sàn, A có thể nhận 40% hoàn phí giao dịch<br>" +
      "B lại mời C đăng ký, khi C giao dịch, B có thể nhận 40% hoàn phí giao dịch, A có thể nhận 10% hoàn phí giao dịch." +
      '<p style="margin-top: 30px;color: #222A55; font-size: 16px;">3) Sau khi trở thành thành viên, A làm thế nào để nhận hoàn tiền giao dịch?</p>' +
      "Nếu bạn B mà A mời cũng trở thành thành viên sàn giao dịch, A có thể nhận hoàn tiền 20USDT<br>" +
      "Nếu C mà B mời cũng trở thành thành viên sàn giao dịch, thì B có thể nhận hoàn tiền 20USDT, A có thể nhận hoàn tiền 10USDT.",
    title2:
      "2. Làm thế nào để trở thành thành viên sàn giao dịch và đối tác cấp cao hơn?",
    con2:
      "Sau khi người dùng mua thẻ điểm 100USDT trở thành thành viên nền tảng RWA, " +
      "chỉ cần đáp ứng hai chỉ tiêu là yêu cầu số thành viên mời và yêu cầu giá trị giao dịch, là có thể tự động nâng cấp thành đối tác cấp cao hơn.",
    example2:
      'Ví dụ:<br><p style="color: #222A55; font-size: 16px;">1) A đã là thành viên sàn giao dịch, vậy làm thế nào để nâng cấp thành đối tác?</p>' +
      "A mời trực tiếp ít nhất 2 thành viên (bao gồm thân phận từ thành viên trở lên), và có giá trị giao dịch trên nền tảng RWA đạt 10000USDT (bao gồm Taker và Maker), là có thể trở thành đối tác RWA;<br>" +
      "A mời trực tiếp ít nhất 5 thành viên (bao gồm thân phận từ thành viên trở lên), và có giá trị giao dịch trên nền tảng RWA đạt 50000USDT (bao gồm Taker và Maker), là có thể trở thành đối tác kim cương RWA;<br>" +
      '<p style="margin-top: 30px">Thành viên là chỉ người dùng mua thẻ điểm 100USDT.</p>',
    example2_2:
      '<p style="color: #222A55; font-size: 16px;">2) Tôi đã là thành viên, có thể mua quyền lợi thành viên để tặng người khác không?</p>' +
      "Với điều kiện bạn đã là thành viên, có thể thông qua việc mua quyền lợi thành viên, tạo mã mời thành viên chỉ định, giúp người khác đăng ký trở thành thành viên chỉ với một thao tác.<br>" +
      "Khi đối phương dùng mã mời quyền lợi thành viên của bạn đăng ký thành công, là có thể trở thành thân phận thành viên trong một bước, không cần qua các bước khác. <br>" +
      "Mỗi mã mời quyền lợi thành viên chỉ có thể dùng một lần, đăng ký thành công là hết hiệu lực.",
    btn_be_member: "Trở thành thành viên sàn giao dịch ngay",
    btn_detail: "Giải thích chi tiết quyền lợi thành viên",
    btn_gift: "Mua thẻ quyền lợi thành viên để tặng người khác",
    btn_check: "Xem tình trạng sử dụng thẻ quyền lợi thành viên",
    title3: "3.Hoàn phí được phát như thế nào?",
    con3: "Mỗi ngày lúc 08:00:00 (GMT+0800) sẽ hoàn trả phần thưởng mời của 24 giờ trước, phát trực tiếp vào tài khoản coin-coin, vui lòng chú ý nhận.",
    reward_cash_rank: "Bảng xếp hạng hoàn tiền",
    invite_record: "Lịch sử mời của tôi",
    reward_record: "Lịch sử hoàn phí của tôi",
    rank: "Xếp hạng",
    partner_lvl: "Cấp đối tác",
    user: "Người dùng",
    time: "Thời gian",
    user_invited: "Người được mời",
    reward_cash_amount: "Số tiền hoàn",
    reward_fee_money: "Số tiền hoàn phí",
    btn_alert: "Bắt đầu hành trình đặc quyền của tôi",
    buy_card: "Mua thẻ quyền lợi thành viên",
    pay_after: "Hiển thị mã mời sau khi thanh toán",
    create_invite_code: "Tạo mã mời",
    assign_user: "Người dùng chỉ định",
    pay_con:
      "Bạn sắp mua thẻ quyền lợi thành viên, sau khi mua thẻ quyền lợi thành viên có thể tặng người khác, vui lòng xác nhận số dư tài khoản coin-coin đủ trước",
    should_pay: "Số tiền phải trả",
    trade_password_placeholder: "Vui lòng nhập mật khẩu giao dịch",
    uid_placeholder: "Vui lòng nhập UID người dùng",
    uid_error: "UID không hợp lệ",
    check: "Kiểm tra",
    not_check: "Vui lòng xác minh danh tính trước",
    check_fail: "Kiểm tra UID thất bại, không thể mua thành viên cho họ",
    is_follow_me: "Người dùng này là người được bạn mời trực tiếp",
    not_follow_me:
      "Người dùng này không phải người được bạn mời trực tiếp, vui lòng cân nhắc khi mua",
    pay_confirm: "Xác nhận thanh toán",
    be_member: "Đã trở thành thành viên",
    cancel: "Hủy",
    buy_complete: "Mua hoàn tất",
    click_copy: "Nhấn để sao chép",
    success_con:
      "Khi người khác dùng mã mời của bạn để đăng ký, là có thể trở thành thân phận thành viên trong một bước. Mỗi mã mời chỉ có thể dùng một lần, đăng ký thành công là hết hiệu lực",
    close: "Đóng",
    has_buy_card: "Thẻ quyền lợi đã mua",
    buy_time: "Thời gian mua",
    invite_code: "Mã mời",
    direct: "Thăng hạng trực tiếp",
    status: "Trạng thái",
    status_0: "Chưa xác thực",
    status_1: "Đã xác thực",
    status_2: "Đang xét duyệt",
    status_3: "Xét duyệt thất bại",
    code_user: "Người sử dụng",
    operation: "Thao tác",
    copy: "Sao chép",
    not_use: "Chưa sử dụng",
    invalid: "Đã hết hiệu lực",
    must_member: "Chỉ thành viên mới có thể mua thẻ quyền lợi",
    activity: {
      title: "Quyền lợi thành viên",
      content1: "Hoàn phí giới thiệu liên tục",
      content2:
        '1. Hoàn phí giao dịch: Thành viên A ("người giới thiệu") mời thành viên B ("người được giới thiệu") đăng ký tại RWA.LTD. Khi thành viên B giao dịch, thành viên A có thể nhận 40% hoàn phí giao dịch của B. Nếu thành viên B tiếp tục giới thiệu thành viên C, thì:',
      content2$1: " - Thành viên B có thể nhận 40% hoàn phí giao dịch của C;",
      content2$2: " - Thành viên A có thể nhận 10% hoàn phí giao dịch của C.",

      content2$2$0:
        "2. Phần thưởng giới thiệu: Sau khi thành viên A giới thiệu thành viên B đăng ký tại RWA.LTD, thành viên A có thể nhận 20 đô la (hoặc USDT tương đương) phần thưởng đăng ký sau khi B đăng ký thành công. Nếu thành viên B tiếp tục giới thiệu thành viên C, thì:",
      content2$2$1:
        " - Thành viên B có thể nhận 20 đô la (hoặc USDT tương đương) phần thưởng đăng ký;",
      content2$2$2:
        " - Thành viên A có thể nhận 10 đô la (hoặc USDT tương đương) phần thưởng giới thiệu cấp hai.",

      content3: "Hoạt động ưu đãi có thời hạn",
      content3$0:
        "1. Gói quà airdrop: Token tài sản tiêu dùng chất lượng trị giá 100 đô la 【Thời gian hoạt động: 19/3/2026 – 19/4/2026】",
      content3$1:
        " - Nội dung airdrop: 150 RWA + 300 DIMD + 300 GCT + 300 TOP100 ",
      content3$2:
        " - Quy tắc phát: Thống kê dữ liệu thành viên vào mỗi Chủ nhật, và phát gói quà tài sản theo thứ tự; tất cả tài sản sẽ được phát hết trong vòng ba tháng.",

      content3$2$0:
        "2. Ưu đãi giảm 50% phí giao dịch 【Thời hạn hiệu lực: 1 năm】",
      content3$2$1:
        " - Giảm phí: Thành viên hưởng ưu đãi giảm 50% phí giao dịch của tất cả cặp giao dịch trong vòng một năm — giao dịch càng nhiều, tiết kiệm càng nhiều.",
      content3$2$2:
        " - Cơ chế khấu trừ phí thành viên: Phí thành viên trị giá 100 đô la đã thanh toán có thể dùng để khấu trừ tối đa 50% phí giao dịch. Trong thời gian khấu trừ, sau khi cộng thêm ưu đãi giảm 50% phí, phí thực tế thành viên phải trả chỉ còn 25% phí gốc.",

      content4: "Từ ngày 19/3/2026 đến ngày 20/3/2026",
      content5: "Ba, phúc lợi hoạt động",
      content6:
        "Phúc lợi 1: Airdrop gói quà lớn tài sản chất lượng của nền tảng trị giá 100USD",
      content7:
        "Thành viên mở mới trong thời gian hoạt động, nhận thêm gói quà lớn tổ hợp tài sản RWA hàng tiêu dùng chất lượng tổng trị giá 100 USD.",
      content8: "Nội dung airdrop: 150 RWA + 300 DIMD + 300 GCT + 300 TOP100",
      content9:
        "Quy tắc phát: Thống kê dữ liệu thành viên vào mỗi Chủ nhật, lần lượt airdrop một loại gói quà tài sản, tất cả gói quà tài sản sẽ được phát hết trong vòng 3 tháng.",
      content10: "Phúc lợi 2: Quyền lợi độc quyền thành viên thường niên",
      content11:
        "Giảm 50% phí: Trong 1 năm phí của tất cả cặp giao dịch được hưởng ưu đãi giảm 50%, giao dịch càng nhiều, tiết kiệm càng nhiều.",
      content12:
        "Phí thành viên khấu trừ phí giao dịch: Phí thành viên 100USD bạn đã thanh toán, có thể dùng trực tiếp để khấu trừ 50% phí giao dịch phát sinh trong tương lai, tương đương được hưởng thêm giảm 50% trên cơ sở giảm 50% phí giao dịch.",
      content13: "Phúc lợi 3: Mời giới thiệu, hưởng ngay hoàn tiền",
      content14:
        "Thưởng mời trực tiếp: Trực tiếp mời bạn bè mở thành viên, bạn có thể nhận hoàn tiền 20USD/USDT.",
      content15:
        "Thưởng mời gián tiếp: Bạn bè lại mời người khác, bạn còn có thể nhận hoàn tiền 10USD/USDT.",
    },
  },
  about: {
    title: "Về chúng tôi",
    titleInfo:
      'RWA.LTD là nền tảng giao dịch token tài sản thế giới thực phi tài chính (Real World Assets, RWA) đầu tiên trên thế giới, do Viện Nghiên cứu Kinh tế Mới Quốc tế Hồng Kông (INERI) tạo ra thông qua công ty con sở hữu toàn bộ RWA Group Limited, vận hành tuân thủ theo luật Hồng Kông với tư cách là nền tảng giao dịch "Token số mục đích hạn chế (Limited Purpose Digital Token)".',
    titleInfo1:
      "Viện Nghiên cứu Kinh tế Mới Quốc tế Hồng Kông (INERI) được ông Phó Nhiêu (CEO) sáng lập năm 2019, là một trong những doanh nghiệp được ươm tạo tại Công viên Khoa học và Công nghệ Hồng Kông (Hong Kong Science and Technology Parks), và nhận nhiều khoản trợ cấp của chính quyền đặc khu Hồng Kông. Trong giai đoạn đầu thành lập, hoạt động chính của INERI là tư vấn ngành trao quyền bằng blockchain. Ông Phó Nhiêu cũng tham gia lâu dài công tác giảng dạy và nghiên cứu tại các trường đại học, từng làm giảng viên thỉnh giảng tại Đại học Hồng Kông, Đại học Thành thị Hồng Kông, Đại học Trung Văn Hồng Kông (Thâm Quyến) và Đại học Bắc Kinh. Từ năm 2023, INERI bắt đầu tập trung bố trí ứng dụng token hóa RWA phi tài chính. Nền tảng NFT China do họ sáng lập thông qua hợp tác với các doanh nghiệp nổi tiếng như BYD (BYDDY), đã chủ trì và thúc đẩy việc phát hành nhiều dự án NFT phi tài chính. Nền tảng đạt hơn 300.000 người dùng đăng ký trong vòng ba tháng kể từ khi ra mắt.",
    titleInfo2:
      "Trên cơ sở kinh nghiệm vận hành nền tảng NFT phong phú và nguồn lực ngành, INERI bắt đầu công tác chuẩn bị nền tảng token đồng nhất (FT) phi tài chính từ cuối năm 2024. Nền tảng RWA.LTD chính thức ra mắt vào giữa tháng 9 năm 2025, trở thành nền tảng đầu tiên trên thế giới tập trung giao dịch token số mục đích hạn chế, cam kết thực hiện biểu đạt số hóa và lưu thông quyền lợi phi tài chính thông qua công nghệ blockchain. Tháng 3 năm 2026, RWA.LTD hoàn tất nâng cấp và cải cách hệ thống nền tảng lần đầu, nâng cao hơn nữa tính an toàn, ổn định và trải nghiệm người dùng của nền tảng, tiếp tục thúc đẩy phát triển hệ sinh thái token hóa RWA phi tài chính.",
  },
  footerAddress: {
    btnVal1: "Tìm kiếm",
    btnVal2: "Xóa",
    btnVal3: "Điện thoại",
    inputPlaceholder: "Vui lòng nhập tên địa điểm",
  },
  download: {
    title: "Tải ứng dụng RWA",
    title1: "Nền tảng thương mại chuỗi ra mắt hoành tráng",
    title2:
      "Sự kết hợp sáng tạo giữa cơ chế token và kinh tế hàng hóa, mang đến cho bạn trải nghiệm hoàn toàn mới",
    h3: "An toàn, ổn định, hiệu quả",
    h1: "Nền tảng giao dịch tài sản kỹ thuật số",
    ios: "Tải IOS",
    android: "Tải Android",
  },
  financial: {
    home: {
      header: "RWAEx Bảo tài chính",
      tip: "Là nền tảng đầu tư sinh lãi từ nắm giữ tài sản blockchain, thu nhập ổn định, bao gồm nhiều loại sản phẩm như định kỳ (tài chính khóa vị), tài chính không kỳ hạn,... cung cấp kênh đầu tư tốt nhất cho người dùng đầu tư ổn định",
      my_had: "Coin tôi nắm giữ",
      ongoing: "Đang diễn ra",
      mining: "Đang đào",
      tobe_started: "Sắp bắt đầu",
      end: "Đã kết thúc",
      rate_year: "Lãi suất năm tham khảo",
      auto: "Linh hoạt",
      buy_min: "Mua tối thiểu",
      mine_min: "Đào tối thiểu",
      assign_coin: "Loại tiền lãi",
      to_end_time: "Còn đến khi kết thúc mua",
      left_position: "Vị thế còn lại",
      lock_position: "Vị thế đã khóa",
      day: "ngày",
      hour: "giờ",
      minutes: "phút",
      seconds: "giây",
      after_start: "sau đó bắt đầu",
    },
  },
  footerPrivacy: {
    title: "Tuyên bố quyền riêng tư",
    titleInfo:
      'Tuyên bố quyền riêng tư này do RWA Group (sau đây gọi là "chúng tôi" hoặc "công ty"; "của RWA Group" nghĩa là "của chúng tôi") đưa ra cho bạn với tư cách là khách truy cập hoặc người dùng của nền tảng [RWA.LTD], trang web [https://www.rwahk.ltd/] cũng như bất kỳ ứng dụng máy tính hoặc thiết bị di động liên quan nào. RWA Group chỉ RWA Group Limited (một công ty trách nhiệm hữu hạn được đăng ký thành lập tại Hồng Kông, số đăng ký kinh doanh 74645397). Tuyên bố này được xây dựng theo Điều lệ Dữ liệu Cá nhân (Quyền riêng tư) ("Điều lệ Quyền riêng tư").',
    titleInfo1: "Phần một: Tuyên bố thu thập dữ liệu cá nhân (PICS)",
    titleInfo2: "A. Mục đích thu thập",
    titleInfo3:
      "Chúng tôi thu thập và lưu trữ dữ liệu cá nhân của bạn để cung cấp và tối ưu hóa dịch vụ của chúng tôi, bao gồm nhưng không giới hạn:",
    titleInfo4: "(a) Tạo và quản lý tài khoản người dùng của bạn;",
    titleInfo5:
      "(b) Xác minh danh tính của bạn theo quy định về chống rửa tiền (AML) và chống tài trợ khủng bố (CFT);",
    titleInfo6:
      "(c) Xử lý các giao dịch của bạn (bao gồm nạp tiền, rút tiền và giao dịch);",
    titleInfo7:
      "(d) Gửi thông báo hành chính và (trong phạm vi được phép) thông tin tiếp thị;",
    titleInfo8: "(e) Tuân thủ nghĩa vụ pháp lý hoặc yêu cầu quản lý hiện hành.",
    titleInfo9: "B. Các loại dữ liệu cá nhân được thu thập",
    titleInfo10: "Dữ liệu cá nhân mà chúng tôi có thể thu thập bao gồm:",
    titleInfo11:
      "(a) Dữ liệu nhận dạng danh tính (ví dụ: họ tên, số CMND/hộ chiếu Hồng Kông);",
    titleInfo12:
      "(b) Dữ liệu liên hệ (ví dụ: địa chỉ email, số điện thoại, địa chỉ cư trú);",
    titleInfo13:
      "(c) Dữ liệu tài chính và giao dịch (ví dụ: địa chỉ ví, lịch sử giao dịch, thông tin tài khoản ngân hàng);",
    titleInfo14:
      "(d) Dữ liệu thiết bị và sử dụng (ví dụ: địa chỉ IP, loại trình duyệt, Cookies).",
    titleInfo15: "C. Hậu quả của việc không cung cấp dữ liệu",
    titleInfo16:
      "Việc cung cấp dữ liệu cá nhân nói chung là tự nguyện. Tuy nhiên, một số dữ liệu là bắt buộc phải cung cấp để sử dụng dịch vụ này. Nếu bạn không thể cung cấp các dữ liệu đó, chúng tôi có thể không cung cấp được sản phẩm hoặc dịch vụ cho bạn, bao gồm nhưng không giới hạn:",
    titleInfo17: "(a) Mở hoặc duy trì tài khoản của bạn;",
    titleInfo18: "(b) Xử lý các giao dịch của bạn;",
    titleInfo19: "(c) Tuân thủ yêu cầu pháp lý hoặc quản lý.",
    titleInfo20: "D. Các loại đối tượng được tiết lộ dữ liệu",
    titleInfo21:
      "Chúng tôi có thể tiết lộ dữ liệu cá nhân của bạn cho các loại đối tượng sau:",
    titleInfo22:
      "(a) Các công ty liên kết và nhà cung cấp dịch vụ của chúng tôi (ví dụ: nhà cung cấp dịch vụ KYC, tổ chức xử lý thanh toán);",
    titleInfo23:
      "(b) Cơ quan chính phủ, cơ quan quản lý hoặc cơ quan thực thi pháp luật theo yêu cầu pháp lý;",
    titleInfo24:
      "(c) Cố vấn pháp lý, tài chính hoặc chuyên môn có trách nhiệm bảo mật.",
    titleInfo25: "E. Tiếp thị trực tiếp",
    titleInfo26:
      "Chúng tôi có thể sử dụng họ tên, số điện thoại di động, địa chỉ email và địa chỉ cư trú của bạn để gửi thông tin tiếp thị về dịch vụ và sản phẩm của chúng tôi. Trừ khi chúng tôi đã có sự đồng ý của bạn hoặc bạn không phản đối, chúng tôi sẽ không sử dụng dữ liệu cá nhân của bạn cho mục đích tiếp thị trực tiếp. Bạn có thể liên hệ với chúng tôi bất cứ lúc nào qua [s@rwa.ltd] để chọn ngừng nhận thông tin tiếp thị.",
    titleInfo27: "F. Quyền truy cập và chỉnh sửa",
    titleInfo28:
      "Bạn có quyền truy cập và yêu cầu chỉnh sửa dữ liệu cá nhân của bạn mà chúng tôi đang nắm giữ theo Điều lệ Quyền riêng tư. Vui lòng gửi yêu cầu liên quan bằng văn bản đến [s@rwa.ltd].",
    titleInfo29: "Phần hai: Tuyên bố chính sách quyền riêng tư (PPS)",
    titleInfo30: "A. Các loại dữ liệu cá nhân được nắm giữ",
    titleInfo31: "Các loại dữ liệu cá nhân mà chúng tôi lưu giữ bao gồm:",
    titleInfo32: "(a) Dữ liệu đăng ký người dùng và nhận dạng danh tính;",
    titleInfo33: "(b) Hồ sơ giao dịch và hoạt động;",
    titleInfo34: "(c) Hồ sơ liên lạc với người dùng;",
    titleInfo35: "(d) Cookies và dữ liệu sử dụng kỹ thuật.",
    titleInfo36: "B. Mục đích sử dụng chính",
    titleInfo37:
      "Mục đích sử dụng dữ liệu cá nhân giống với mục đích đã nêu trong PICS ở trên.",
    titleInfo38: "C. Lưu giữ dữ liệu",
    titleInfo39:
      'Chúng tôi chỉ lưu giữ dữ liệu cá nhân của bạn trong thời gian cần thiết để đạt được mục đích thu thập dữ liệu này hoặc theo yêu cầu của pháp luật (ví dụ: quy định AML/CFT). Sau khi thời hạn liên quan kết thúc, dữ liệu đó sẽ được xóa an toàn hoặc xử lý ẩn danh. Mặc dù có quy định trên, bạn đã đồng ý trong "Thỏa thuận sử dụng nền tảng" rằng chúng tôi có thể lưu giữ một số thông tin nhất định trong thời hạn lên đến sáu (6) năm.',
    titleInfo40: "D. Biện pháp an toàn",
    titleInfo41:
      "Chúng tôi áp dụng các biện pháp kỹ thuật và tổ chức phù hợp để bảo vệ dữ liệu cá nhân của bạn khỏi bị truy cập, xử lý, xóa hoặc mất mát trái phép.",
    titleInfo42: "E. Truy cập và chỉnh sửa dữ liệu",
    titleInfo43: "Nội dung phần này giống như đã nêu trong PICS ở trên.",
    titleInfo44: "F. Sử dụng Cookies",
    titleInfo45:
      "Chúng tôi có thể sử dụng Cookies hoặc công nghệ tương tự để nâng cao trải nghiệm người dùng và phân tích lưu lượng truy cập trang web. Bạn có thể tắt Cookies thông qua cài đặt trình duyệt, nhưng điều này có thể ảnh hưởng đến việc sử dụng bình thường một số chức năng.",
    titleInfo46: "Ngày cập nhật: [2025/8/8]",
    titleInfo47: "Thông tin liên hệ: [s@rwa.ltd]",
  },
  footerAgreement: {
    title: "Thỏa thuận sử dụng nền tảng",
    titleTime: "Cập nhật lần cuối: ngày 28 tháng 8 năm 2025",
    titleInfo1:
      "Nếu bạn chưa hiểu và chấp nhận đầy đủ nội dung dưới đây, bạn không nên mua, nắm giữ, tiêu dùng hoặc chuyển nhượng token lưu thông của nền tảng.",
    titleInfo2:
      'Toàn bộ nội dung trong Thỏa thuận sử dụng nền tảng này (sau đây gọi là "Thỏa thuận này") tạo thành một thỏa thuận có hiệu lực pháp lý ràng buộc giữa bạn và RWA Group (sau đây gọi là "chúng tôi"). RWA Group bao gồm RWA Group Limited (một công ty trách nhiệm hữu hạn được đăng ký thành lập tại Hồng Kông; số đăng ký kinh doanh 74645397), bất kỳ chủ thể liên kết nào của công ty này, toàn bộ nhân viên của các chủ thể nói trên, nhà thầu dịch vụ bên ngoài cũng như cố vấn bên ngoài. Thỏa thuận này áp dụng cho các mối quan hệ pháp lý liên quan giữa bạn và chúng tôi, bao gồm nhưng không giới hạn quan hệ pháp lý phát sinh từ việc bạn mua, nắm giữ, tiêu dùng hoặc chuyển nhượng bất kỳ token nào lưu thông trên nền tảng (sau đây gọi là "token lưu thông của nền tảng") tại',
    titleInfo3:
      "nền tảng RWA.LTD, trang web [https://rwa.ltd] cũng như các ứng dụng máy tính hoặc thiết bị di động liên kết khác",
    titleInfo4:
      '(sau đây gọi chung là "nền tảng"). Khi truy cập hoặc sử dụng nền tảng, đăng ký tài khoản nền tảng, mua, nắm giữ, tiêu dùng hoặc chuyển nhượng token lưu thông của nền tảng, hoặc tham gia các hoạt động khác liên quan đến hoặc dựa trên nền tảng (sau đây gọi chung là "hoạt động nền tảng" hoặc "hoạt động"), bạn xác nhận và đồng ý rằng bạn sẽ tuân thủ Thỏa thuận này. Nếu bạn thực hiện hoạt động nền tảng đối với bất kỳ token lưu thông nào của nền tảng, bạn xác nhận và đồng ý rằng bạn sẽ tuân thủ thỏa thuận được xây dựng riêng cho hàng hóa hoặc dịch vụ mà token đó đại diện, thỏa thuận này có thể được trình bày trên nền tảng dưới nhiều hình thức, bao gồm nhưng không giới hạn sách trắng token (sau đây gọi là "thỏa thuận sản phẩm"). Bạn tiếp tục xác nhận và đồng ý rằng, trên cơ sở hợp lý về mặt thương mại, chúng tôi có thể đơn phương cập nhật hoặc sửa đổi tất cả các thỏa thuận nói trên theo từng thời điểm và không cần thông báo trước đặc biệt, và bạn nên đọc và hiểu phiên bản mới nhất của các thỏa thuận này cũng như bất kỳ tài liệu bổ sung nào được viện dẫn trong đó trước khi thực hiện bất kỳ hoạt động nền tảng nào.',
    titleInfo5: "Cảnh báo rủi ro và sự đồng ý",
    titleInfo6:
      'Để tránh nghi ngờ, phần cảnh báo rủi ro là một phần không thể tách rời của Thỏa thuận này, có hiệu lực pháp lý ngang bằng với các phần khác. Trước khi đưa ra bất kỳ quyết định nào liên quan đến token lưu thông của nền tảng hoặc thực hiện bất kỳ giao dịch nào, bạn nên thực hiện mọi biện pháp hợp lý để đảm bảo đã hiểu đầy đủ giao dịch đó, và đánh giá độc lập tính phù hợp cũng như rủi ro của nó. Trước khi đưa ra bất kỳ quyết định nào liên quan đến token lưu thông của nền tảng, bạn nên đảm bảo mình có đủ thông tin. Nếu bạn có thắc mắc về bất kỳ nội dung nào của token lưu thông nền tảng, hoạt động nền tảng hoặc Thỏa thuận này, bạn nên tìm kiếm ý kiến chuyên môn độc lập. RWA Group đã xác định token lưu thông của nền tảng là "token số mục đích hạn chế" được định nghĩa tại Điều 53ZR của Điều lệ Hồng Kông về chống rửa tiền và chống tài trợ khủng bố ("AMLO"), tức là điểm thưởng hoặc điểm khen thưởng khách hàng; tài sản dùng trong trò chơi; hoặc bất kỳ giá trị dưới dạng số nào phù hợp với mô tả sau đây — (i) tương tự điểm thưởng hoặc điểm khen thưởng khách hàng hay tài sản dùng trong trò chơi; và (ii) theo ý định của bên phát hành, giá trị dưới dạng số đó không thể chuyển đổi thành tiền hoặc phương tiện trao đổi khác được công chúng chấp nhận. Do đó, theo Điều 53ZRA AMLO, token lưu thông của nền tảng không thuộc "tài sản ảo", "VA" hay "Virtual Asset" theo AMLO. Token lưu thông của nền tảng không được cấu trúc hay bán ra dưới dạng chứng khoán hoặc bất kỳ hình thức sản phẩm đầu tư nào khác. Token lưu thông của nền tảng chưa qua bất kỳ cơ quan quản lý nào thẩm định, đăng ký hoặc cấp phép. RWA Group không thực hiện và cũng không có ý định thực hiện bất kỳ hoạt động nào liên quan đến token lưu thông của nền tảng tại bất kỳ khu vực tài phán nào mà pháp luật liên quan cấm. Bạn nên đảm bảo mọi hoạt động liên quan đến token lưu thông của nền tảng đều hợp pháp trong khu vực tài phán hiện hành.',
    titleInfo7:
      "Bằng việc này, bạn xác nhận rằng bạn hiểu và chấp nhận nhiều loại rủi ro (bao gồm nhưng không giới hạn các rủi ro sau đây) cũng như toàn bộ tổn thất do các rủi ro này gây ra:",
    titleInfo8: "A. Rủi ro liên quan đến công nghệ blockchain và an ninh mạng",
    titleInfo9:
      "Do token lưu thông của nền tảng dựa trên công nghệ blockchain, bất kỳ sự cố, sụp đổ hay từ bỏ nào của blockchain liên quan đều có thể gây ảnh hưởng bất lợi nghiêm trọng đến token lưu thông của nền tảng. Ngoài ra, những tiến bộ về mật mã học hoặc tiến bộ công nghệ như tính toán lượng tử có thể tạo ra rủi ro cho token lưu thông của nền tảng bằng cách làm mất hiệu lực cơ chế đồng thuận mật mã của blockchain nền tảng. Giống như các token mã hóa phi tập trung khác dựa trên công nghệ blockchain, token lưu thông của nền tảng dễ bị tấn công bởi các node hoặc validator chịu trách nhiệm xác minh/xác nhận giao dịch của token lưu thông nền tảng trên blockchain liên quan. Bất kỳ cuộc tấn công thành công nào cũng có thể tạo ra rủi ro cho token lưu thông của nền tảng. Hacker hoặc các nhóm, tổ chức có ý đồ xấu khác có thể can thiệp vào token lưu thông của nền tảng bằng nhiều cách, bao gồm nhưng không giới hạn tấn công phần mềm độc hại, tấn công từ chối dịch vụ, tấn công đồng thuận, tấn công Sybil, tấn công trá hình và tấn công giả mạo.",
    titleInfo10:
      "B. Rủi ro liên quan đến tính thanh khoản không đủ của token lưu thông nền tảng",
    titleInfo11:
      "Token lưu thông của nền tảng không có thị trường tồn tại sẵn, việc bán token lưu thông của nền tảng có thể không tạo ra một thị trường sôi động hoặc có tính thanh khoản. Người nắm giữ có thể đối mặt với rủi ro thanh khoản của token lưu thông nền tảng. RWA Group không chịu trách nhiệm về việc lưu thông và giao dịch token lưu thông của nền tảng trên bất kỳ thị trường nào. Không có chủ thể nào có nghĩa vụ mua token lưu thông của nền tảng từ bất kỳ người nắm giữ nào, cũng không có chủ thể nào bảo đảm tính thanh khoản hay giá thị trường của token lưu thông nền tảng. Do đó, RWA Group không đảm bảo token lưu thông của nền tảng sẽ có bất kỳ nhu cầu hay thị trường nào. RWA Group có quyền điều chỉnh, hạn chế hoặc tạm dừng tính thanh khoản và mọi hoạt động khác của token lưu thông nền tảng vì nhiều lý do khác nhau (ví dụ như thay đổi về pháp luật, chính sách hoặc thực thi pháp luật), và không chịu bất kỳ trách nhiệm nào đối với các điều chỉnh, hạn chế và tạm dừng đó.",
    titleInfo12: "C. Rủi ro liên quan đến biến động giá",
    titleInfo13:
      "Giá token lưu thông của nền tảng thường có thể biến động tương đối do các yếu tố bên ngoài như thị trường tài sản cơ sở cụ thể (ví dụ sở hữu trí tuệ, sản phẩm hoặc dịch vụ liên quan), và có thể biến động lớn trong ngắn hạn. Sự sụt giảm giá của một tài sản blockchain đại diện có thể dẫn đến thiếu niềm tin vào ngành blockchain, ngay cả khi tài sản đó không liên quan đến token lưu thông của nền tảng, việc giá của nó giảm cũng có thể làm suy giảm niềm tin của toàn bộ ngành blockchain, từ đó ảnh hưởng đến thị trường của token lưu thông nền tảng. Giá thực tế của giao dịch token lưu thông nền tảng đối mặt với rủi ro thực chất, và có thể biến động mạnh do điều kiện thị trường và các yếu tố khác nằm ngoài sự kiểm soát của RWA Group.",
    titleInfo14: "D. Rủi ro liên quan đến các hạn chế quản lý không chắc chắn",
    titleInfo15:
      'Trừ khi nền tảng chính thức nêu rõ đặc biệt, token lưu thông của nền tảng chưa được niêm yết trên bất kỳ nền tảng giao dịch tài sản ảo được cấp phép nào theo AMLO Hồng Kông, và cũng không đảm bảo sẽ được niêm yết giao dịch trên các nền tảng nói trên trong tương lai. Điều quan trọng là, mặc dù token lưu thông của nền tảng được thiết kế và xây dựng như "token số mục đích hạn chế" hoặc token sử dụng không có bất kỳ thuộc tính đầu tư nào, và tuyệt đối không phải là "tài sản ảo" hay chứng khoán hoặc sản phẩm đầu tư khác được định nghĩa tại Điều 53ZRA của AMLO, nhưng do sự thay đổi về quy tắc pháp lý, thái độ hay môi trường thực thi pháp luật, hoặc vì các lý do khác mà RWA Group không thể kiểm soát, RWA Group có toàn quyền tùy ý điều chỉnh, hạn chế hoặc tạm dừng bất kỳ hoạt động nào liên quan đến token lưu thông của nền tảng, và RWA Group không chịu bất kỳ trách nhiệm bồi thường nào về việc đó. Nếu bạn dự định thực hiện bất kỳ hành động nào (trực tiếp hoặc gián tiếp) đối với token lưu thông của nền tảng, bạn sẽ chịu trách nhiệm tuân thủ tất cả luật, quy định và quy tắc hiện hành, và cung cấp mọi cảnh báo rủi ro cũng như tiết lộ thích hợp.',
    titleInfo16: "E. Rủi ro không lường trước",
    titleInfo17:
      "Token mã hóa như token lưu thông của nền tảng là một công nghệ mới và chưa được kiểm chứng. Ngoài các rủi ro nói trên, việc mua, nắm giữ, tiêu dùng, chuyển nhượng và các hoạt động khác đối với token lưu thông của nền tảng có thể liên quan đến các rủi ro khác mà RWA Group không thể lường trước hoặc kiểm soát một cách hợp lý. Các rủi ro này có thể xuất hiện theo cách hoặc dưới hình thức tổ hợp không thể lường trước.",
    titleInfo18: "F. Rủi ro thay đổi chính sách nền tảng",
    titleInfo19:
      "RWA Group dựa trên (i) những cân nhắc thương mại hợp pháp mà mình cho là đúng, (ii) sự hiểu biết về luật và chính sách hiện hành, hoặc (iii) sự hiểu biết về xu hướng luật và chính sách, bảo lưu quyền thay đổi bất cứ lúc nào tính chất và nội dung của token lưu thông nền tảng, hoạt động nền tảng, Thỏa thuận này và bất kỳ thỏa thuận sản phẩm nào (bao gồm nhưng không giới hạn kế hoạch cung cấp và phân phối, chính sách và cơ chế của chúng). Trước khi đưa ra bất kỳ quyết định nào liên quan đến token lưu thông của nền tảng, bạn nên đảm bảo đã đọc kỹ và hiểu đầy đủ phiên bản mới nhất của Thỏa thuận này và các nội dung liên quan khác đã được cập nhật trên nền tảng tại thời điểm đó.",
    titleInfo20: "1. Tài khoản.",
    titleInfo21: "1.1 Đăng ký.",
    titleInfo22:
      "Bạn cần đăng ký tài khoản trên nền tảng để đảm bảo bất kỳ quyền lợi nào bạn được hưởng theo Thỏa thuận này. Tuy nhiên, việc chưa đăng ký hoặc chưa đăng nhập tài khoản không ảnh hưởng đến việc Thỏa thuận này có hiệu lực ràng buộc đối với bạn và chúng tôi theo pháp luật hiện hành. Việc mở tài khoản đồng nghĩa với việc bạn đồng ý chỉ sử dụng tài khoản đó cho chính mình, mọi bên thứ ba sử dụng tài khoản của bạn cần có sự đồng ý bằng văn bản của chúng tôi. Bạn chịu toàn bộ trách nhiệm đối với mọi hoạt động thực hiện trên tài khoản và hậu quả pháp lý phát sinh từ đó.",
    titleInfo23: "1.2 Biện pháp hạn chế.",
    titleInfo24:
      "Nền tảng có quyền đơn phương áp dụng các biện pháp hạn chế như đóng băng tài khoản, hạn chế giao dịch và/hoặc khóa tài sản trong các trường hợp sau đây mà không cần thông báo trước cho người dùng:",
    titleInfo25:
      "a. Nhận được chỉ thị của cơ quan tư pháp, cơ quan quản lý hoặc cơ quan có thẩm quyền khác;",
    titleInfo26:
      "b. Phát hiện hoặc nghi ngờ hợp lý rằng tài khoản có giao dịch bất thường, nghi ngờ rửa tiền, lừa đảo, huy động vốn trái phép, thao túng thị trường, tấn công mạng hoặc các hành vi vi phạm pháp luật khác;",
    titleInfo27:
      "c. Phát hiện hoặc nghi ngờ hợp lý rằng tài khoản vi phạm Thỏa thuận này hoặc các quy tắc khác của nền tảng; hoặc",
    titleInfo28:
      "d. Nền tảng cho rằng một cách hợp lý cần áp dụng bất kỳ biện pháp hạn chế nào đối với một số tài khoản nhất định nhằm bảo vệ người dùng khác, nền tảng hoặc lợi ích công cộng.",
    titleInfo29:
      "Sau khi nền tảng áp dụng biện pháp đóng băng, người dùng có thể nộp các tài liệu liên quan theo yêu cầu của nền tảng để xin gỡ bỏ đóng băng. Nền tảng có quyền tự quyết định việc có gỡ bỏ đóng băng hay không và bảo lưu quyền quyết định cuối cùng.",
    titleInfo30: "1.3 Người dùng tự nguyện hủy tài khoản.",
    titleInfo31:
      "Người dùng có thể xin hủy tài khoản của mình thông qua quy trình do nền tảng cung cấp. Việc hủy tài khoản phải đáp ứng các điều kiện sau:",
    titleInfo32:
      "a. Tài khoản không có giao dịch hoặc tranh chấp chưa giải quyết;",
    titleInfo33: "b. Tài khoản không còn tài sản dư;",
    titleInfo34:
      "c. Không đang trong trạng thái điều tra tư pháp, thẩm tra quản lý hoặc bị hạn chế bởi kiểm soát rủi ro của nền tảng.",
    titleInfo35:
      "Một khi tài khoản đã hủy sẽ không thể khôi phục; dữ liệu liên quan sẽ được xử lý theo luật, quy định hiện hành và chính sách quyền riêng tư của nền tảng.",
    titleInfo36: "1.4 Nền tảng chấm dứt tài khoản.",
    titleInfo37:
      "Nếu nền tảng đánh giá hợp lý rằng tồn tại một trong các trường hợp sau, nền tảng có quyền đơn phương chấm dứt tài khoản và thu hồi quyền sử dụng mà không cần có sự đồng ý của người dùng:",
    titleInfo38:
      "a. Tài khoản vi phạm Thỏa thuận này hoặc pháp luật liên quan, hoặc tồn tại rủi ro tuân thủ nghiêm trọng;",
    titleInfo39:
      "b. Tài khoản không thực hiện bất kỳ hoạt động nền tảng nào trong ba năm liên tục, nền tảng coi như người dùng đã từ bỏ tài khoản;",
    titleInfo40:
      "c. Thông tin danh tính tài khoản giả mạo, mạo danh, đăng ký trùng lặp, v.v.;",
    titleInfo41:
      "d. Tài khoản thực hiện bất kỳ hành vi nào gây tổn hại đến lợi ích, uy tín hoặc an toàn của nền tảng;",
    titleInfo42:
      "e. Các lý do hợp lý khác mà nền tảng xác định cần thu hồi tài khoản.",
    titleInfo43:
      "Sau khi nền tảng chấm dứt tài khoản, tùy tình huống quyết định việc có hoàn trả tài sản hợp pháp còn lại trong tài khoản hay không, nếu tài khoản có hành vi vi phạm pháp luật hoặc các hành vi khác gây tổn hại lợi ích của nền tảng, nền tảng có quyền khấu trừ tổn thất liên quan trước khi hoàn trả.",
    titleInfo44: "2. Thông tin và liên lạc",
    titleInfo45: "2.1 Xác minh danh tính.",
    titleInfo46:
      "Bạn cần tuân theo quy trình xác minh danh tính của chúng tôi trước khi mở tài khoản, bằng cách cung cấp cho chúng tôi một số thông tin về bạn, và trong trường hợp liên quan, cung cấp thông tin của bất kỳ người dùng bên thứ ba nào được ủy quyền. Tất cả thông tin bạn cung cấp phải đầy đủ, chính xác và trung thực. Nếu thông tin có thay đổi, bạn phải cập nhật thông tin đó.",
    titleInfo47:
      "Bạn ủy quyền cho chúng tôi tiến hành trực tiếp hoặc thông qua bên thứ ba các truy vấn mà chúng tôi cho là cần thiết để xác minh danh tính của bạn và của bất kỳ người dùng bên thứ ba nào được ủy quyền, nhằm bảo vệ bạn và/hoặc chúng tôi khỏi rủi ro lừa đảo, rửa tiền, tài trợ khủng bố hoặc các hành vi tội phạm khác, và áp dụng các biện pháp mà chúng tôi cho là cần thiết dựa trên kết quả truy vấn.",
    titleInfo48:
      "Khi chúng tôi tiến hành truy vấn, bạn xác nhận và đồng ý rằng thông tin cá nhân của bạn cũng như thông tin của bất kỳ người dùng bên thứ ba nào được ủy quyền có thể được tiết lộ cho các tổ chức xác minh danh tính, ghi chép dữ liệu tuân thủ, tham chiếu tín dụng, phòng chống gian lận hoặc phòng chống tội phạm tài chính, các tổ chức này có thể phản hồi đầy đủ cho truy vấn của chúng tôi.",
    titleInfo49: "2.2 Thẩm định tăng cường.",
    titleInfo50:
      "Chúng tôi có thể yêu cầu bạn tuân theo quy trình thẩm định tăng cường của chúng tôi bằng cách nộp thêm thông tin về bạn, doanh nghiệp của bạn hoặc bất kỳ người dùng bên thứ ba nào được ủy quyền, cung cấp thêm hồ sơ hoặc tài liệu, hoặc gặp mặt trực tiếp với đại diện được ủy quyền của RWA Group.",
    titleInfo51: "2.3 Yêu cầu thông tin",
    titleInfo52:
      "Nhằm tuân thủ bất kỳ luật hiện hành, yêu cầu xác minh danh tính, phát hiện rửa tiền, tài trợ khủng bố, lừa đảo hoặc bất kỳ tội phạm nào khác, hoặc các lý do hợp lệ khác, chúng tôi có thể yêu cầu bạn cung cấp thông tin bất cứ lúc nào. Bạn đồng ý cung cấp thông tin liên quan mà chúng tôi yêu cầu, và ủy quyền cho chúng tôi lưu giữ hồ sơ thông tin này trong thời hạn tối đa sáu (6) năm.",
    titleInfo53: "2.4 Liên lạc qua email đã đăng ký.",
    titleInfo54:
      "Bạn xác nhận có nghĩa vụ kiểm tra email của mình, bao gồm cả thư rác. Thông tin do RWA Group đơn phương gửi đi được coi là đã truyền đạt hiệu lực đến bạn ngay sau khi gửi. Việc không phản hồi hoặc không hành động trong vòng bảy (7) ngày làm việc kể từ khi gửi sẽ được coi là bạn không có ý kiến phản đối và đồng ý với nội dung mà RWA Group trình bày trong email đó.",
    titleInfo55:
      "Chúng tôi có thể gửi thông báo có hiệu lực hoặc hậu quả pháp lý hoặc các thông báo khác đến hòm thư đã đăng ký của bạn qua email. Bạn có trách nhiệm đảm bảo địa chỉ email là mới nhất và chính xác. Thông báo một khi đã được gửi đến địa chỉ email mà bạn cung cấp, được coi là đã được gửi đến. Nếu vì bạn không cập nhật kịp thời địa chỉ email hoặc không kiểm tra email kịp thời mà dẫn đến bất kỳ hậu quả pháp lý nào, bạn tự chịu trách nhiệm. Bạn chỉ có thể gửi thông báo cho chúng tôi theo cách mà chúng tôi chỉ định theo từng thời điểm.",
    titleInfo56: "2.5 Thông báo.",
    titleInfo57:
      "Tất cả thông báo chính thức, bao gồm nhưng không giới hạn thông báo về khuyến mãi, cuộc thi và airdrop, sẽ được liệt kê trên nền tảng. Các thông báo này rất quan trọng và có thể liên quan đến quyết định hoạt động của bạn đối với token lưu thông của nền tảng. Bạn có trách nhiệm truy cập nền tảng định kỳ để xem các thông báo liên quan, bất kể các thông báo này được phát ra trước hay sau hành vi tương ứng của bạn. Mọi hậu quả pháp lý phát sinh do không xem thông báo kịp thời, bạn tự chịu trách nhiệm.",
    titleInfo58: "2.6 Ghi âm.",
    titleInfo59:
      "Bạn đồng ý rằng chúng tôi có thể ghi lại các cuộc liên lạc giữa chúng tôi với bạn dưới bất kỳ hình thức nào (bao gồm nhưng không giới hạn liên lạc điện tử, điện thoại hoặc trao đổi trực tiếp), và xác nhận rằng các bản ghi âm này có thể được dùng làm bằng chứng hiệu lực về việc liên lạc giữa hai bên. Bạn đồng ý rằng các cuộc gọi điện thoại có thể được ghi âm mà không sử dụng tín hiệu báo hoặc thông báo thêm nào khác.",
    titleInfo60:
      "3. Các hoạt động bị cấm. Nếu người dùng thực hiện hoặc bị nền tảng nghi ngờ hợp lý thực hiện các hoạt động bị cấm dưới đây, nền tảng có quyền lập tức áp dụng các biện pháp bao gồm nhưng không giới hạn hạn chế giao dịch, đóng băng tài khoản, chấm dứt tài khoản, thu hồi token và chấm dứt dịch vụ, đồng thời bảo lưu quyền truy cứu trách nhiệm theo pháp luật. Không làm ảnh hưởng đến bất kỳ hạn chế hoặc ràng buộc nào khác trong Thỏa thuận này, bạn đồng ý rằng bạn và bất kỳ người dùng bên thứ ba nào sẽ không:",
    titleInfo61:
      "a. Vi phạm Thỏa thuận này hoặc bất kỳ thỏa thuận nào được xác lập theo Thỏa thuận này và các thỏa thuận liên quan (bao gồm nhưng không giới hạn bất kỳ thỏa thuận sản phẩm nào);",
    titleInfo62:
      "b. Thực hiện bất kỳ hoạt động nào đối với token lưu thông của nền tảng với mục đích đầu tư, coi token lưu thông của nền tảng như bất kỳ sản phẩm đầu tư nào; hành động theo bất kỳ cách thức nào cố ý hoặc khách quan khiến token lưu thông của nền tảng bị coi là sản phẩm đầu tư; hoặc thực hiện bất kỳ hoạt động nào làm gia tăng rủi ro token lưu thông của nền tảng bị cơ quan quản lý của bất kỳ khu vực tài phán nào coi là sản phẩm đầu tư;",
    titleInfo63:
      "c. Đưa ra với bên thứ ba hoặc công khai bất kỳ lời nói, cáo buộc hoặc bình luận (dù rõ ràng hay ngụ ý) sai sự thật,",
    titleInfo64: "bất lợi, chỉ trích hoặc bôi nhọ",
    titleInfo65:
      "về chúng tôi, trừ khi lời nói đó dựa trên sự thật khách quan và đã được phán quyết hoặc quyết định có hiệu lực hỗ trợ;",
    titleInfo66:
      "d. Thực hiện hoạt động trên nền tảng theo cách vi phạm lợi ích công cộng, đạo đức công cộng hoặc lợi ích hợp pháp của người khác;",
    titleInfo67:
      "e. Thực hiện hành vi thao túng thị trường (như bơm giá xả hàng, giao dịch đối ứng, tự mua tự bán, giao dịch trước, nhồi báo giá, lừa đảo hoặc thao tác phân lớp, v.v.), bất kể có bị pháp luật hiện hành cấm hay không;",
    titleInfo68:
      "f. Thực hiện hoạt động gian lận, hoặc khiến chúng tôi nghi ngờ rằng bạn hoặc bất kỳ người dùng được ủy quyền nào thực hiện hoạt động và/hoặc giao dịch gian lận;",
    titleInfo69:
      "g. Sử dụng token lưu thông của nền tảng để thực hiện hoặc tham gia các trò xổ số, hoạt động cờ bạc, đấu giá theo phí, dự đoán thể thao hoặc lập kèo, giải thể thao ảo với giải thưởng tiền mặt, trò chơi trực tuyến, cuộc thi, rút thăm hoặc bất kỳ trò chơi may rủi nào không do chúng tôi tổ chức và giám sát;",
    titleInfo70:
      "h. Cung cấp thông tin sai lệch, không chính xác hoặc gây hiểu lầm liên quan đến hoạt động của bạn đối với token lưu thông của nền tảng, liên lạc với chúng tôi hoặc các vấn đề khác liên quan đến Thỏa thuận này;",
    titleInfo71:
      "i. Sửa đổi hoặc điều chỉnh toàn bộ hoặc bất kỳ phần nào của nền tảng, hoặc hợp nhất, tích hợp nền tảng vào các chương trình hoặc ứng dụng khác;",
    titleInfo72:
      "j. Sửa đổi, sao chép, nhân bản, tải xuống, lưu trữ, truyền tải, phát tán, chuyển nhượng, tháo rời, phát sóng, xuất bản, xóa hoặc thay đổi bất kỳ tuyên bố hay nhãn bản quyền nào, hoặc cấp phép, cấp phép lại, bán, sao chép phản chiếu, thiết kế, cho thuê, bán, tư nhân hóa, cấp quyền bảo đảm đối với quyền sở hữu trí tuệ đó hoặc bất kỳ phần nào của quyền sở hữu trí tuệ, hoặc tạo ra tác phẩm phái sinh, hoặc trục lợi từ bất kỳ phần nào của quyền sở hữu trí tuệ theo bất kỳ cách nào;",
    titleInfo73:
      "k. Vi phạm hoặc cố gắng vi phạm (i) bất kỳ luật hiện hành nào, (ii) bản quyền, bằng sáng chế, nhãn hiệu, bí mật thương mại hoặc quyền sở hữu trí tuệ khác của chúng tôi hoặc bất kỳ bên thứ ba nào, hoặc (iii) quyền lợi công cộng hoặc quyền riêng tư.",
    titleInfo74: "4. Lợi ích thực chất và xung đột lợi ích",
    titleInfo75: "4.1 Lợi ích thực chất.",
    titleInfo76:
      "Bạn hiểu và đồng ý rằng RWA Group không có nghĩa vụ tiết lộ cho bạn hoặc sử dụng bất kỳ thông tin nào mà mình biết để mưu cầu lợi ích cho bạn, và không chịu trách nhiệm về bất kỳ hậu quả nào phát sinh do không tiết lộ hoặc không sử dụng.",
    titleInfo77:
      "Bạn tiếp tục xác nhận rằng chúng tôi có thể nhận được theo từng thời điểm bất kỳ thông tin nào về token lưu thông của nền tảng hoặc hoạt động nền tảng, những thông tin này có thể ảnh hưởng đến giá hoặc tính thanh khoản của token. Chúng tôi có thể sử dụng hợp pháp các thông tin nói trên cho hoạt động hoặc lợi ích của chính mình.",
    titleInfo78: "4.2 Hoạt động của RWA Group.",
    titleInfo79:
      "RWA Group hoặc bất kỳ nhân viên nào được ủy quyền có thể thực hiện các hoạt động liên quan đến token lưu thông của nền tảng, mặc dù các hoạt động này dựa trên mục đích hợp pháp (bao gồm nhưng không giới hạn cung cấp thanh khoản cho token, ngăn chặn bên thứ ba thao túng thị trường một cách ác ý, v.v.), bạn hiểu và đồng ý rằng các hoạt động này tạo thành xung đột lợi ích có thể xảy ra với bạn.",
    titleInfo80: "4.3 Nhà cung cấp thanh khoản",
    titleInfo81: "Bạn xác nhận, đồng ý và chấp nhận:",
    titleInfo82:
      "a. Chúng tôi có thể chỉ định một hoặc nhiều nhà cung cấp thanh khoản (trong đó có thể bao gồm chính RWA Group) để giám sát và điều chỉnh thị trường token lưu thông của nền tảng, và bất kỳ nhà cung cấp thanh khoản nào cũng có thể thực hiện giao dịch với bạn với tư cách là đối tác giao dịch;",
    titleInfo83:
      "b. Nhà cung cấp thanh khoản còn có thể nắm giữ vị thế của nhiều loại tài sản ảo (bao gồm token lưu thông của nền tảng, v.v.) trong hoạt động cung cấp thanh khoản của họ, bao gồm cả vị thế tài sản ảo trái ngược với vị thế của bạn;",
    titleInfo84:
      "c. Hoạt động cung cấp thanh khoản như vậy có thể được thực hiện thông qua giao dịch theo thuật toán. Việc cung cấp thanh khoản này có thể ảnh hưởng đến giá token lưu thông của nền tảng và tính thanh khoản cần thiết để thực hiện giao dịch;",
    titleInfo85:
      "d. Việc cung cấp thanh khoản dựa trên mục đích hợp pháp (ví dụ duy trì ổn định thị trường nền tảng, ngăn chặn bên thứ ba thao túng thị trường ác ý, v.v.), bạn không được đưa ra bất kỳ khiếu nại pháp lý, yêu cầu bồi thường thiệt hại hoặc đơn xin lệnh cấm nào đối với chúng tôi hoặc những người liên quan vì hành vi cung cấp thanh khoản;",
    titleInfo86:
      "e. Chúng tôi có thể thu được lợi nhuận hoặc chịu tổn thất khi cung cấp thanh khoản, lợi nhuận hoặc tổn thất này không cấu thành bất kỳ nghĩa vụ hay trách nhiệm nào đối với người dùng.",
    titleInfo87: "5. Mua và tiêu dùng token lưu thông của nền tảng",
    titleInfo88: "Thông tin về",
    titleInfo89: "token lưu thông, hàng hóa hoặc dịch vụ của nền tảng",
    titleInfo90:
      "như tính chất, chất lượng và giá cả được nền tảng hiển thị chỉ mang tính chất trưng bày, không phải là lời chào hàng, nhiều nhất chỉ là lời mời chào hàng do bên bán hoặc bên phát hành token được ghi rõ trong thỏa thuận sản phẩm cụ thể đưa ra.",
    titleInfo91:
      "Khi bạn mua hoặc tiêu dùng token lưu thông của nền tảng trên nền tảng để đổi lấy hàng hóa hoặc dịch vụ, vui lòng xác nhận kỹ tên gọi, giá cả, số lượng, kiểu loại, quy cách và kích thước của hàng hóa hoặc dịch vụ được đổi, hoặc phạm vi, nội dung và thời gian của quyền lợi, hoặc các yêu cầu hạn chế đối với bên trao đổi cùng các vấn đề quan trọng khác, và kiểm tra các thông tin như tên tài khoản, email cũng như địa chỉ nhận hàng của bạn khi đặt lệnh trao đổi. Nếu thông tin nhận hàng bạn điền không phải chính bạn, hành vi và ý chí của người nhận hàng được coi là hành vi và ý chí của bạn, bạn phải chịu trách nhiệm liên đới đối với hậu quả pháp lý của hành vi và ý chí của người nhận hàng.",
    titleInfo92:
      "Hành vi tiêu dùng của bạn phải dựa trên nhu cầu tiêu dùng thực sự, không được có hành vi mua ác ý, khiếu nại ác ý, thổi phồng ác ý đối với hàng hóa hoặc dịch vụ hay các hành vi khác làm rối loạn trật tự giao dịch bình thường của nền tảng. Để duy trì trật tự và an toàn giao dịch của nền tảng, RWA Group có quyền áp dụng các biện pháp bao gồm nhưng không giới hạn đóng lệnh, hạn chế tài khoản, đóng băng tài sản khi phát hiện các trường hợp nói trên.",
    titleInfo93:
      "Trừ khi có tuyên bố rõ ràng ngược lại, khi bạn mua, giao dịch, tiêu dùng token lưu thông của nền tảng để đổi lấy hàng hóa hoặc dịch vụ thực tế hoặc thực hiện các hoạt động nền tảng khác, chỉ liên quan đến quan hệ pháp lý giữa bạn với bên bán hoặc bên phát hành token, RWA Group không được xác định theo bất kỳ cách nào là bên tham gia quan hệ pháp lý đó. Chúng tôi cũng không đưa ra bất kỳ tuyên bố hay bảo đảm rõ ràng hoặc ngụ ý nào về token lưu thông nền tảng liên quan, quyền lợi mà token đại diện (hàng hóa, dịch vụ hoặc các quyền lợi phi tài chính khác), bao gồm nhưng không giới hạn việc thực hiện thành công token, tính có thể tiêu thụ hoặc tính phù hợp cho mục đích cụ thể của hàng hóa hoặc dịch vụ tương ứng.",
    titleInfo94:
      "Bạn đồng ý rằng trong mọi trường hợp, sẽ không đưa ra bất kỳ cáo buộc pháp lý, yêu cầu bồi thường thiệt hại hoặc lệnh cấm nào theo bất kỳ nghĩa nào đối với RWA Group dựa trên các hoạt động nền tảng như hành vi tiêu dùng token.",
    titleInfo95: "6. Tuyên bố miễn trừ trách nhiệm về kỹ thuật",
    titleInfo96: "6.1 Không có bất kỳ tuyên bố hay bảo đảm nào.",
    titleInfo97:
      'Bất kỳ thông tin nào chúng tôi cung cấp qua nền tảng cũng như việc liên lạc giữa bạn và chúng tôi đều được cung cấp trên cơ sở "hiện trạng" và "sẵn có", không phải là bất kỳ tuyên bố hay bảo đảm nào về tính chính xác, đầy đủ hoặc kịp thời, dù là rõ ràng hay ngụ ý, các tuyên bố nói trên có hiệu lực trong phạm vi tối đa được pháp luật hiện hành cho phép.',
    titleInfo98:
      "Cụ thể, chúng tôi phủ nhận rõ ràng tất cả các bảo đảm ngụ ý, bao gồm nhưng không giới hạn bảo đảm về quyền sở hữu, tính có thể bán, tính phù hợp cho mục đích cụ thể và/hoặc không xâm phạm quyền của người khác. Chúng tôi không đưa ra bất kỳ tuyên bố hay bảo đảm nào về tính liên tục, ổn định hoặc kịp thời khi bạn truy cập hoặc sử dụng nền tảng và liên lạc liên quan, cũng như tính đầy đủ, chính xác của bất kỳ nội dung tài liệu nào liên quan đến các hoạt động nói trên. Điều này có thể khiến bạn không thể thực hiện các hoạt động liên quan đến token lưu thông của nền tảng trong một khoảng thời gian nhất định, và có thể dẫn đến chậm trễ thời gian giao dịch liên quan.",
    titleInfo99:
      "6.2 Tạm dừng truy cập. Chúng tôi có thể tạm dừng việc bạn truy cập hoặc sử dụng nền tảng theo từng thời điểm để tiến hành bảo trì an ninh định kỳ hoặc khẩn cấp.",
    titleInfo100:
      "7. Thay đổi Thỏa thuận này và nền tảng. Chúng tôi có thể toàn quyền tự quyết định sửa đổi bất cứ lúc nào Thỏa thuận này và bất kỳ nội dung nào của nền tảng, bao gồm chức năng và nội dung của token lưu thông nền tảng, Thỏa thuận này cũng như các hoạt động liên quan.",
    titleInfo101:
      "Khi bạn đăng ký tài khoản nền tảng hoặc tiếp tục truy cập, sử dụng nền tảng, hoặc mua, nắm giữ, tiêu dùng hoặc chuyển nhượng token lưu thông của nền tảng, được coi là bạn đã đọc đầy đủ, hiểu và đồng ý chấp nhận Thỏa thuận này sau khi cập nhật.",
    titleInfo102:
      "Nếu bạn không muốn chấp nhận bất kỳ thay đổi nào, bạn nên lập tức ngừng nắm giữ token lưu thông của nền tảng và ngừng thực hiện bất kỳ hoạt động nền tảng nào, và hủy tài khoản của bạn bằng cách liên hệ với người liên quan của RWA Group.",
    titleInfo103:
      "8. Hợp tác tuân thủ. Bạn đồng ý phối hợp với RWA Group trong bất kỳ cuộc điều tra và điều chỉnh nào đối với token lưu thông của nền tảng hoặc hoạt động nền tảng vì lý do tuân thủ. Nếu có bất kỳ cơ quan quản lý nào liên hệ với bạn về token lưu thông của nền tảng hoặc hoạt động liên quan, bạn đồng ý thông báo ngay cho RWA Group trong phạm vi pháp luật hiện hành cho phép, và cung cấp tất cả thông tin liên quan.",
    titleInfo104:
      "9. Tuyên bố và bảo đảm. Bằng việc này, bạn tuyên bố và bảo đảm với chúng tôi rằng bạn luôn tuân thủ các điều sau:",
    titleInfo105:
      "a. Bạn đã hiểu đầy đủ về nghiệp vụ nền tảng cũng như bản chất và mọi rủi ro của token lưu thông nền tảng thông qua việc tự học hoặc tư vấn chuyên gia pháp lý hoặc chuyên viên tư vấn;",
    titleInfo106:
      "b. Tất cả tài liệu và thông tin bạn cung cấp cho chúng tôi đều trung thực, chính xác, đầy đủ và mới nhất về mọi mặt, chúng tôi có thể dựa vào các thông tin này trong mọi trường hợp;",
    titleInfo107:
      "c. Tất cả các quyết định liên quan đến Thỏa thuận này hoàn toàn và độc quyền dựa trên phán đoán của chính bạn, và được đưa ra sau khi bạn đã đánh giá độc lập nguồn lực tài chính, năng lực, rủi ro liên quan mà bạn sẵn sàng chấp nhận cũng như mục tiêu tài chính của bạn;",
    titleInfo108: "d. Bạn có đầy đủ quyền hạn, sự ủy quyền và năng lực để:",
    titleInfo109: "a) Truy cập và sử dụng nền tảng;",
    titleInfo110:
      "b) Thực hiện bất kỳ hoạt động nào đối với token lưu thông của nền tảng;",
    titleInfo111:
      "c. Bạn đã có được tất cả sự đồng ý, cho phép, ủy quyền, phê duyệt và thỏa thuận cần thiết của bên thứ ba, cũng như tất cả các phê duyệt, đồng ý, cho phép, đăng ký, tuyên bố và báo cáo bắt buộc hoặc mong muốn có được từ các cơ quan quản lý chính phủ, bộ phận chính phủ, ủy ban, cơ quan đại diện hoặc tổ chức có thẩm quyền khác, để:",
    titleInfo112: "a) Truy cập và sử dụng nền tảng;",
    titleInfo113:
      "b) Thực hiện bất kỳ hoạt động nào đối với token lưu thông của nền tảng;",
    titleInfo114: "10. Tính chất của trách nhiệm của chúng tôi.",
    titleInfo115:
      "Bạn hiểu và đồng ý rằng mối quan hệ giữa bạn và RWA Group, hoặc bất kỳ vấn đề nào khác (bao gồm nhưng không giới hạn việc bạn gửi tiền vào tài khoản nền tảng), không cấu thành bất kỳ quan hệ ủy thác, thụ ủy, đại lý hoặc hợp danh nào, chúng tôi không có nghĩa vụ thụ ủy đối với bạn. RWA Group có quyền vì lý do thương mại bên ngoài hoặc bên trong điều chỉnh một cách hợp lý giá cả và các tham số liên quan của bất kỳ token lưu thông nền tảng, sản phẩm hoặc dịch vụ nào mà không cần thông báo trước cho bạn.",
    titleInfo116:
      "Chúng tôi cũng không cung cấp bất kỳ tư vấn đầu tư, pháp lý, thuế, kế toán hoặc tài chính nào, và không bảo đảm về hiệu suất thị trường cũng như phê duyệt quản lý của dịch vụ nền tảng, token lưu thông nền tảng và hoạt động nền tảng, bạn nên tự thực hiện nghĩa vụ phán đoán, quyết định và tuân thủ tại khu vực tài phán tương ứng, và xác nhận hiểu và chấp nhận các rủi ro liên quan phát sinh từ việc sử dụng nền tảng cũng như giao dịch token lưu thông của nền tảng.",
    titleInfo117:
      "Trừ khi có tuyên bố rõ ràng đặc biệt, chúng tôi không được xác định theo bất kỳ cách nào là bên phát hành token lưu thông nền tảng và/hoặc bên bán quyền lợi mà token đại diện, chúng tôi chỉ thiết lập kênh liên lạc cho bên phát hành token lưu thông nền tảng và/hoặc bên bán quyền lợi mà token đại diện với người dùng.",
    titleInfo118: "11. Bồi thường.",
    titleInfo119:
      'Bằng việc này, bạn cam kết và đồng ý rằng, khi bất kỳ bên thứ ba, cơ quan chính phủ hoặc tổ chức ngành nghề nào đưa ra khiếu nại, kiện tụng, hành động, yêu cầu, tranh chấp, cáo buộc hoặc điều tra đối với chúng tôi, bạn sẽ bồi thường toàn bộ cho chúng tôi và giúp chúng tôi không phải gánh chịu bất kỳ khiếu nại, trách nhiệm, bồi thường thiệt hại (bao gồm thiệt hại thực tế và gián tiếp), tổn thất (bao gồm bất kỳ tổn thất tiền bạc trực tiếp hoặc gián tiếp, tổn thất danh dự, v.v.), chi phí và phí tổn nào, bao gồm nhưng không giới hạn tất cả tiền lãi, tiền phạt cũng như phí luật sư hợp lý về pháp lý và khác cùng các phí chuyên môn khác ("tổn thất bồi thường"), các khiếu nại hoặc tổn thất này phát sinh từ hoặc liên quan theo bất kỳ cách nào đến bất kỳ vấn đề nào sau đây:',
    titleInfo120:
      "a. Việc bạn truy cập hoặc sử dụng nền tảng hoặc bất kỳ hoạt động nào đối với token lưu thông của nền tảng;",
    titleInfo121:
      "b. Việc bạn vi phạm hoặc bị nghi ngờ vi phạm Thỏa thuận này hoặc các thỏa thuận liên quan khác, bao gồm bất kỳ thỏa thuận sản phẩm nào;",
    titleInfo122: "c. Việc bạn vi phạm bất kỳ luật hiện hành nào;",
    titleInfo123: "d. Việc bạn xâm phạm quyền của bất kỳ bên thứ ba nào.",
    titleInfo124: "12. Trách nhiệm",
    titleInfo125: "12.1 Trách nhiệm của chúng tôi.",
    titleInfo126:
      "Trong phạm vi tối đa được pháp luật hiện hành cho phép, RWA Group không chịu bất kỳ trách nhiệm nào đối với bất kỳ tổn thất trực tiếp và gián tiếp nào mà bạn hoặc bất kỳ bên thứ ba nào phải gánh chịu do hoạt động nền tảng hoặc token lưu thông của nền tảng. Không làm ảnh hưởng đến quy định nói trên, trong mọi trường hợp, tổng trách nhiệm của RWA Group không vượt quá số tiền phí mà bạn đã thanh toán cho RWA Group trong mười hai (12) tháng trước khi sự kiện gây ra tổn thất xảy ra. Số tiền này sẽ được chúng tôi thanh toán cho bạn, như là khoản bồi thường toàn bộ và cuối cùng của chúng tôi đối với tất cả tổn thất và khiếu nại, và đủ để giải trừ toàn bộ trách nhiệm của chúng tôi đối với các tổn thất và khiếu nại đó. Bạn xác nhận và đồng ý rằng RWA Group không biết bất kỳ tình huống đặc biệt nào liên quan đến bạn, và khoản bồi thường tiền bạc nói trên là biện pháp khắc phục duy nhất và đầy đủ của bạn, bạn không có quyền hoặc từ bỏ quyền yêu cầu bất kỳ khiếu nại hoặc biện pháp khắc phục nào khác theo luật hoặc luật công bình, bao gồm nhưng không giới hạn bất kỳ bồi thường thiệt hại, yêu cầu quyền tài sản, lệnh cấm và/hoặc thực hiện cụ thể nào.",
    titleInfo127: "12.2 Giới hạn trách nhiệm.",
    titleInfo128:
      "Mặc dù các điều khoản khác trong Thỏa thuận này có thể quy định khác, bằng việc này bạn xác nhận và đồng ý rằng, trong mọi trường hợp, chúng tôi không chịu các trách nhiệm sau đây đối với bạn hoặc bất kỳ cá nhân, tổ chức nào khác:",
    titleInfo129:
      "a. Bất kỳ tổn thất trực tiếp hoặc gián tiếp nào (bao gồm tổn thất tiền bạc, tổn thất cơ hội kinh doanh, v.v.), dù phát sinh từ các vấn đề sau đây hay liên quan đến bất kỳ vấn đề nào khác của token lưu thông nền tảng:",
    titleInfo130:
      "a) Bất kỳ rủi ro nào được ghi rõ trong cảnh báo rủi ro (cảnh báo rủi ro sẽ được cập nhật theo từng thời điểm);",
    titleInfo131:
      "b) Hoạt động, chức năng, tính an toàn hoặc tính khả dụng của giao thức cơ sở của các tài sản ảo khác liên quan đến token lưu thông nền tảng hoặc hoạt động nền tảng;",
    titleInfo132:
      "c) Bất kỳ hành động hoặc không hành động nào theo Thỏa thuận này;",
    titleInfo133:
      "d) Bất kỳ sự thiếu chính xác, khiếm khuyết hoặc thiếu sót nào trong bất kỳ dạng dữ liệu nào, lỗi truyền tải hoặc chậm trễ của bất kỳ dữ liệu nào như vậy, cũng như sự gián đoạn của bất kỳ dữ liệu nào như vậy;",
    titleInfo134:
      "e) Việc bảo trì định kỳ hoặc không định kỳ mà chúng tôi tiến hành, bao gồm việc gián đoạn dịch vụ và thay đổi phát sinh từ đó;",
    titleInfo135:
      "f) Thiệt hại do hành vi, không hành động hoặc vi phạm Thỏa thuận này của người dùng khác, cũng như hành vi của bất kỳ bên thứ ba nào khác gây ra;",
    titleInfo136:
      "g) Bất kỳ việc chấm dứt, tạm dừng, đóng băng hoặc hạn chế truy cập nào đối với hoạt động nền tảng;",
    titleInfo137:
      "h) Việc chúng tôi không thể liên lạc với bạn qua thông tin liên hệ mà bạn cung cấp;",
    titleInfo138:
      "i) Việc chúng tôi từ chối hoặc chậm trễ thực hiện bất kỳ chỉ thị nào;",
    titleInfo139:
      "j) Tổn thất mà bạn phải gánh chịu do hành vi của bên thứ ba, bao gồm hành vi lừa đảo của bên thứ ba liên quan đến RWA Group hoặc token lưu thông của nền tảng;",
    titleInfo140:
      "k) Bất kỳ sự kiện mạng blockchain, phân nhánh (Fork) hoặc airdrop (Airdrop) nào;",
    titleInfo141:
      "l) Tính đúng đắn, chất lượng, chính xác, an toàn, đầy đủ, đáng tin cậy, hiệu suất, kịp thời, định giá hoặc tính sẵn có liên tục của sản phẩm hoặc dịch vụ do nền tảng hoặc chúng tôi cung cấp; sự chậm trễ, thiếu sót hoặc lỗi của bất kỳ nội dung nào do nền tảng hoặc chúng tôi cung cấp;",
    titleInfo142:
      "m) Bất kỳ giao dịch, chỉ thị hoặc thao tác nào bạn thực hiện trên nền tảng.",
    titleInfo143:
      "b. Bất kỳ tổn thất hoặc thiệt hại đặc biệt, mang tính trừng phạt, gia trọng, ngẫu nhiên, gián tiếp hoặc hệ quả nào, dù phát sinh từ hoặc liên quan đến nền tảng của chúng tôi, token lưu thông của nền tảng, Thỏa thuận này, thỏa thuận sản phẩm và/hoặc bất kỳ thỏa thuận nào theo Thỏa thuận này hoặc liên quan đến Thỏa thuận này;",
    titleInfo144:
      "c. Bất kỳ tổn thất hoặc thiệt hại nào mà bạn có thể phải gánh chịu do sai sót rõ ràng (Manifest Error) và/hoặc biến động thị trường cực đoan (bao gồm nhưng không giới hạn thị trường tài sản ảo của bất kỳ khu vực nào, thị trường sản phẩm cụ thể và thị trường tài chính) và/hoặc việc hủy/sửa đổi bất kỳ giao dịch nào, dù là trực tiếp hay gián tiếp, đặc biệt hay hệ quả, bao gồm nhưng không giới hạn tổn thất tiền bạc và tổn thất cơ hội; và/hoặc",
    titleInfo145:
      "d. Bất kỳ khiếu nại nào mà bạn không khởi kiện thông qua hành động pháp lý chính thức trong vòng một năm kể từ ngày xảy ra sự việc liên quan đến vấn đề khiếu nại.",
    titleInfo146: "12.3 Liên lạc trước.",
    titleInfo147:
      "Bạn đồng ý rằng khi phát sinh bất kỳ tranh chấp nào với chúng tôi, trước khi tiếp cận bất kỳ cơ quan quản lý hoặc cơ quan tư pháp nào, trước tiên hãy liên hệ với chúng tôi để trao đổi về mọi tình huống liên quan đến tranh chấp, bạn đồng ý sẽ không tiết lộ bất kỳ thông tin nào liên quan đến tranh chấp cho bên thứ ba.",
    titleInfo148: "13. Luật áp dụng và giải quyết tranh chấp.",
    titleInfo149:
      "Thỏa thuận này chịu sự điều chỉnh của pháp luật Đặc khu Hành chính Hồng Kông và được giải thích theo pháp luật đó. Bạn đồng ý đưa tất cả các tranh chấp hoặc khiếu nại đó ra thẩm quyền chuyên thuộc của tòa án Đặc khu Hành chính Hồng Kông và từ bỏ mọi phản đối đối với thẩm quyền của tòa án.",
    titleInfo150:
      "Nếu RWA Group khởi kiện bạn, RWA Group sẽ thông báo cho bạn qua địa chỉ email mà bạn cung cấp. Bạn đồng ý rằng bất kỳ thông báo nào gửi đến địa chỉ email hoặc địa chỉ bưu điện đó đều được coi là hợp lệ, bất kể có liên quan đến tính đầy đủ của việc tống đạt hay không. Bạn có trách nhiệm đảm bảo địa chỉ email cung cấp khi đăng ký tài khoản là mới nhất và chính xác.",
    titleInfo151:
      "Hai bên đồng ý rằng tất cả thông tin liên quan đến kiện tụng phải được giữ bí mật. Mặc dù vậy, một bên có thể tiết lộ thông tin bí mật đó trong các trường hợp sau:",
    titleInfo152: "a. Nếu được sự đồng ý bằng văn bản của bên kia;",
    titleInfo153:
      "b. Theo yêu cầu của pháp luật hiện hành hoặc quy định của bất kỳ cơ quan quản lý hay giám sát có thẩm quyền nào, hoặc theo lệnh của tòa án hoặc cơ quan có thẩm quyền khác;",
    titleInfo154:
      "c. Nếu thông tin bí mật liên quan không còn là thông tin bí mật, mà đã đi vào phạm vi công cộng thông qua cách thức không vi phạm Thỏa thuận này.",
    titleInfo155: "14. Từ bỏ quyền kiện tập thể.",
    titleInfo156:
      "Bạn và RWA Group đồng ý rằng bất kỳ khiếu nại nào chỉ được đưa ra với tư cách cá nhân, chứ không phải với tư cách nguyên đơn hoặc thành viên tập thể trong vụ kiện tập thể hoặc vụ kiện đại diện. Bạn tiếp tục đồng ý từ bỏ quyền đưa các khiếu nại đó thành vụ kiện tập thể, gộp chung, đại diện hoặc kiểm sát viên tư nhân trong phạm vi được pháp luật hiện hành cho phép. Nếu không có sự đồng ý của RWA Group, khiếu nại cá nhân không được hợp nhất hoặc gộp thành một vụ kiện duy nhất. Việc từ bỏ này áp dụng trong phạm vi tối đa được pháp luật hiện hành cho phép.",
    titleInfo157: "15. Chấm dứt Thỏa thuận.",
    titleInfo158:
      "Thỏa thuận này có hiệu lực pháp lý ràng buộc đối với bạn kể từ khi bạn truy cập nền tảng lần đầu, và tiếp tục có hiệu lực cho đến khi bạn chính thức hủy tài khoản của mình chỉ theo quy trình hủy tài khoản được nêu trong Thỏa thuận này, mới có thể chấm dứt Thỏa thuận này. Nếu sau khi Thỏa thuận chấm dứt, bạn lại truy cập nền tảng, Thỏa thuận sẽ lại có hiệu lực đối với bạn. Sau khi Thỏa thuận chấm dứt, các điều khoản không liên quan đến việc sử dụng nền tảng trong Thỏa thuận này vẫn tiếp tục có hiệu lực, các điều khoản này bao gồm nhưng không giới hạn Điều 8 đến Điều 14 của Thỏa thuận này (bao gồm cả bản thân Điều 8 và Điều 14).",
    titleInfo159: "16. Khác",
    titleInfo160: "16.1 Thỏa thuận toàn vẹn.",
    titleInfo161:
      "Thỏa thuận này cùng với bất kỳ thỏa thuận sản phẩm nào tạo thành thỏa thuận toàn vẹn giữa bạn và chúng tôi. Bạn xác nhận rằng, trừ khi được quy định rõ ràng trong Thỏa thuận này hoặc bất kỳ thỏa thuận sản phẩm nào, bạn sẽ không dựa vào bất kỳ tuyên bố, phát biểu, bảo đảm hay đảm bảo nào (dù do sơ suất hay vô ý).",
    titleInfo162: "16.2 Chuyển nhượng.",
    titleInfo163:
      "Nếu không có sự đồng ý trước bằng văn bản của chúng tôi, bạn không được chuyển nhượng hoặc chuyển giao bất kỳ quyền hoặc nghĩa vụ nào của bạn theo Thỏa thuận này. Bất kỳ việc chuyển nhượng hoặc chuyển giao trái phép nào đều vô hiệu và không tạo ra hiệu lực ràng buộc đối với RWA Group. Tuy nhiên, chúng tôi có thể chuyển nhượng hoặc chuyển giao theo từng thời điểm bất kỳ quyền hoặc nghĩa vụ nào theo Thỏa thuận này cho bất kỳ bên nào khác, bao gồm nhưng không giới hạn các trường hợp liên quan đến sáp nhập, mua lại hoặc tái cơ cấu doanh nghiệp khác với bất kỳ chủ thể nào của RWA Group.",
    titleInfo164: "16.3 Tính vô hiệu.",
    titleInfo165:
      "Mỗi phần của Thỏa thuận này, khi đánh giá tính hợp pháp, hiệu lực hoặc khả năng thi hành, có thể tách rời khỏi các phần khác trong Thỏa thuận này. Nếu bất kỳ phần nào của Thỏa thuận này vào bất kỳ thời điểm nào trở nên bất hợp pháp, vô hiệu hoặc không thể thi hành, thì tính hợp pháp, hiệu lực hoặc khả năng thi hành của các phần còn lại sẽ không vì thế mà bị ảnh hưởng hoặc tổn hại.",
    titleInfo166: "16.4 Ngôn ngữ.",
    titleInfo167:
      "Để tiện cho việc đọc, Thỏa thuận này có thể được cung cấp bản dịch, bản dịch có thể sử dụng ngôn ngữ khác ngoài tiếng Anh. Tuy nhiên, phiên bản tiếng Anh của Thỏa thuận này là phiên bản chính thức, bạn nên đảm bảo hiểu đầy đủ phiên bản tiếng Anh; rủi ro hoặc tổn thất phát sinh do không hiểu, bạn tự chịu trách nhiệm.",
    titleInfo168: "16.5 Tồn tại.",
    titleInfo169:
      "Mặc dù hoạt động của bạn trên nền tảng có thể đã bị tạm dừng hoặc chấm dứt, nhưng Thỏa thuận này cùng bất kỳ thỏa thuận sản phẩm áp dụng nào vẫn tiếp tục áp dụng cho bạn khi bạn cần thực hiện nghĩa vụ hoặc trách nhiệm theo Thỏa thuận này hoặc bất kỳ thỏa thuận sản phẩm áp dụng nào.",
    titleInfo170: "16.6 Không từ bỏ.",
    titleInfo171:
      "Bất kỳ sự chậm trễ hoặc thiếu sót nào của chúng tôi khi thực hiện bất kỳ quyền hoặc biện pháp khắc phục nào theo Thỏa thuận này đều không được coi là từ bỏ việc thực hiện quyền hoặc biện pháp khắc phục đó trong tương lai, hoặc từ bỏ bất kỳ quyền hoặc biện pháp khắc phục nào khác theo Thỏa thuận này. Các quyền và biện pháp khắc phục được cung cấp trong Thỏa thuận này mang tính tích lũy, không loại trừ bất kỳ quyền hoặc biện pháp khắc phục nào do pháp luật hiện hành cung cấp. Trừ khi được lập thành văn bản và có chữ ký của RWA Group, bất kỳ sự từ bỏ nào đều không được coi là có hiệu lực.",
    titleInfo172: "16.7 Thuế.",
    titleInfo173:
      "Trách nhiệm xác định các khoản tiền bạn thanh toán hoặc nhận có áp dụng thuế hay không, cũng như thu, báo cáo và nộp đúng khoản thuế, thuộc về bạn. Bạn đồng ý rằng chúng tôi không chịu trách nhiệm xác định xem hoạt động token lưu thông nền tảng của bạn có áp dụng bất kỳ khoản thuế nào không, cũng không chịu trách nhiệm thu, báo cáo hoặc nộp bất kỳ khoản thuế nào phát sinh từ đó. Bạn phải tự khai báo và nộp cho cơ quan thuế liên quan các khoản thuế phát sinh từ hoạt động nền tảng, chúng tôi không chịu bất kỳ trách nhiệm liên đới nào.",
    titleInfo174: "16.8 Quyền riêng tư.",
    titleInfo175:
      "Chúng tôi cam kết đảm bảo tất cả dữ liệu cá nhân được gửi qua nền tảng tuân thủ nghiêm ngặt các quy định liên quan của Điều lệ Dữ liệu Cá nhân (Quyền riêng tư) (PDPO). Vì các mục đích khác nhau, bạn có thể được mời cung cấp dữ liệu cá nhân cho RWA Group theo từng thời điểm thông qua nền tảng hoặc cách thức khác. Thông tin cá nhân có thể bao gồm họ tên, số điện thoại, địa chỉ bưu điện hoặc địa chỉ email. RWA Group sẽ nêu rõ mục đích và cách sử dụng khi mời bạn cung cấp các thông tin đó. Trừ khi pháp luật cho phép hoặc yêu cầu, RWA Group sẽ không tiết lộ dữ liệu cá nhân của bạn cho bất kỳ bên thứ ba nào khi chưa có sự đồng ý trước của bạn.",
  },
};
export default viVN;
